(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"] && !Shopify.designMode) return;
  try {
    
  (function() {
    /* Cart-page sync for EXTERNAL cart-mutations (Schnellkauf aus JS-Rastern,
       quick-view ATC etc.). Those dispatch ne:cart-updated. The drawer
       is suppressed on this template (Rule 182) so we just reload —
       cleanest for cross-section adds.

       Internal mutations from cart-items (remove / qty-change) use a
       DISTINCT event name (ne:cart-rerendered) so this listener never
       fires for them — they refetch + swap the section HTML themselves
       and don't need the heavyweight reload. */
    document.addEventListener('ne:cart-updated', function () {
      window.location.reload();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collapsible-content"] && !Shopify.designMode) return;
  try {
    
  // FAQPage JSON-LD — built client-side from the rendered accordion items.
  // Server-side is impossible here: theme-block settings are opaque to the
  // parent section (content_for + nested @theme blocks, Rule 66/171).
  (function () {
    function collect(section, list) {
      var items = section.querySelectorAll('.ne-acc-item');
      for (var i = 0; i < items.length; i++) {
        var qEl = items[i].querySelector('.ne-acc-item__heading');
        var aEl = items[i].querySelector('.ne-acc-item__content');
        if (!qEl || !aEl) continue;
        var q = (qEl.textContent || '').trim();
        var a = (aEl.textContent || '').replace(/\s+/g, ' ').trim();
        if (q && a) list.push({ '@type': 'Question', name: q, acceptedAnswer: { '@type': 'Answer', text: a } });
      }
    }
    function run() {
      var old = document.getElementById('ne-faq-jsonld');
      if (old) old.remove();
      var sections = document.querySelectorAll('[data-ne-faq-schema="1"]');
      if (!sections.length) return;
      var entities = [];
      for (var i = 0; i < sections.length; i++) collect(sections[i], entities);
      if (!entities.length) return;
      var ld = { '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: entities };
      var s = document.createElement('script');
      s.type = 'application/ld+json';
      s.id = 'ne-faq-jsonld';
      s.textContent = JSON.stringify(ld);
      document.head.appendChild(s);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-switcher"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSwitcher(root) {
      (root || document).querySelectorAll('[data-cs-section]').forEach(function (section) {
        if (section.__csInit) return;
        section.__csInit = true;

        var style = section.getAttribute('data-cs-style') || 'coverflow';
        var track = section.querySelector('[data-cs-labels]');
        var viewport = section.querySelector('[data-cs-viewport]');
        var labels = Array.prototype.slice.call(section.querySelectorAll('[data-cs-label]'));
        var panels = Array.prototype.slice.call(section.querySelectorAll('[data-cs-panel]'));
        var prevBtn = section.querySelector('[data-cs-prev]');
        var nextBtn = section.querySelector('[data-cs-next]');
        var count = labels.length;
        if (!count) return;
        var idx = 0;

        function center() {
          if (style !== 'coverflow' || !track || !viewport) return;
          var active = labels[idx];
          if (!active) return;
          var tx = (viewport.clientWidth / 2) - (active.offsetLeft + active.offsetWidth / 2);
          track.style.transform = 'translateX(' + tx + 'px)';
        }

        /* Nachladen eines Reiters, der nur als Huelle ausgeliefert wurde.
           Geholt wird `<collection.url>?section_id=<section.id>` — Shopify rendert dort
           DIESELBE Section mit denselben Einstellungen, deshalb passt die nachgeladene
           Karte optisch exakt. Aus der Antwort wird nur das Panel uebernommen.
           ⚠️ Scheitert der Abruf, bleibt der Reiter NICHT leer: die Huelle traegt einen
           versteckten Link auf die Kollektion, der dann eingeblendet wird. */
        function ensurePanel(i) {
          var p = panels[i];
          if (!p || !p.hasAttribute('data-cs-lazy') || p.__csBusy) return;
          p.__csBusy = true;
          var url = p.getAttribute('data-cs-url');
          if (!url) return;
          fetch(url, { credentials: 'same-origin' })
            .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var frisch = doc.querySelector('[data-cs-panel]');
              if (!frisch) throw new Error('kein Panel in der Antwort');
              p.innerHTML = frisch.innerHTML;
              p.removeAttribute('data-cs-lazy');
              /* Neu eingehaengte Karten brauchen dieselben Initialisierungen wie
                 gerenderte (Schnellansicht, Swatches, Warenkorb). */
              document.dispatchEvent(new CustomEvent('ne:content-added', { detail: { root: p } }));
            })
            .catch(function () {
              p.__csBusy = false;
              var skel = p.querySelector('[data-cs-skeleton]');
              var fall = p.querySelector('[data-cs-fallback]');
              if (skel) skel.remove();
              if (fall) fall.hidden = false;
            });
        }

        function setActive(i, focusIt) {
          idx = Math.max(0, Math.min(count - 1, i));
          labels.forEach(function (l, j) {
            var on = j === idx;
            l.classList.toggle('is-active', on);
            l.classList.toggle('is-adjacent', Math.abs(j - idx) === 1);
            l.setAttribute('aria-selected', on ? 'true' : 'false');
            l.setAttribute('tabindex', on ? '0' : '-1');
          });
          panels.forEach(function (p, j) { p.hidden = j !== idx; });
          ensurePanel(idx);
          if (prevBtn) prevBtn.disabled = idx === 0;
          if (nextBtn) nextBtn.disabled = idx === count - 1;
          center();
          if (focusIt && labels[idx]) labels[idx].focus();
        }

        if (prevBtn) prevBtn.addEventListener('click', function () { setActive(idx - 1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { setActive(idx + 1); });

        labels.forEach(function (l, j) {
          /* Vorwaermen, damit der Klick nicht auf die Anfrage wartet. `pointerover`
             deckt Maus und Stift ab, `focus` die Tastatur; auf Beruehrung feuert es
             unmittelbar vor dem Klick, was immer noch hilft. */
          l.addEventListener('pointerover', function () { ensurePanel(j); }, { passive: true });
          l.addEventListener('focus', function () { ensurePanel(j); });
          l.addEventListener('click', function () { setActive(j); });
          l.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowRight') { e.preventDefault(); setActive(idx + 1, true); }
            else if (e.key === 'ArrowLeft') { e.preventDefault(); setActive(idx - 1, true); }
            else if (e.key === 'Home') { e.preventDefault(); setActive(0, true); }
            else if (e.key === 'End') { e.preventDefault(); setActive(count - 1, true); }
          });
        });

        window.addEventListener('resize', center);
        section.__csActivate = setActive;

        setActive(0);
        // Re-centre once fonts/images settle (label widths shift).
        requestAnimationFrame(center);
        setTimeout(center, 250);
        if (document.fonts && document.fonts.ready) { document.fonts.ready.then(center); }
      });
    }

    document.addEventListener('DOMContentLoaded', function () { initSwitcher(document); });
    document.addEventListener('shopify:section:load', function (e) { initSwitcher(e.target); });
    // Activate the panel whose collection block the merchant just selected.
    document.addEventListener('shopify:block:select', function (e) {
      var panel = e.target && e.target.closest ? e.target.closest('[data-cs-panel]') : null;
      if (!panel) return;
      var section = panel.closest('[data-cs-section]');
      if (section && section.__csActivate) {
        section.__csActivate(parseInt(panel.getAttribute('data-cs-index'), 10) || 0);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-collection-section]');
    if (!section) return;

    /* ─── Sort: redirect on change ─────────────────────────────── */
    var sortSelect = section.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    /* ─── Filter form: debounced submit (page reload) ──────────── */
    var filterForm = section.querySelector('[data-filter-form]');
    var filterInputs = section.querySelectorAll('[data-filter-input]');
    var debounceTimer;

    function submitFilterForm() {
      if (!filterForm) return;
      var formData = new FormData(filterForm);
      var params = new URLSearchParams();
      for (var pair of formData.entries()) {
        if (pair[1] !== '' && pair[1] !== null && pair[1] !== undefined) {
          params.append(pair[0], pair[1]);
        }
      }
      // Preserve sort_by if not in form
      if (sortSelect && sortSelect.value && !params.has('sort_by')) {
        params.set('sort_by', sortSelect.value);
      }
      var qs = params.toString();
      window.location.href = window.location.pathname + (qs ? '?' + qs : '');
    }

    filterInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(submitFilterForm, 600);
      });
    });

    /* ─── Mobile filter drawer toggle ──────────────────────────── */
    var filterToggle = section.querySelector('[data-filter-toggle]');
    var filterSidebar = section.querySelector('[data-filter-sidebar]');
    var filterBackdrop = section.querySelector('[data-filter-backdrop]');
    var filterCloseBtn = section.querySelector('[data-filter-close]');

    function openFilters() {
      if (!filterSidebar) return;
      filterSidebar.setAttribute('data-open', '1');
      if (filterBackdrop) filterBackdrop.setAttribute('data-open', '1');
      if (filterToggle) filterToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeFilters() {
      if (!filterSidebar) return;
      filterSidebar.removeAttribute('data-open');
      if (filterBackdrop) filterBackdrop.removeAttribute('data-open');
      if (filterToggle) filterToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (filterToggle) {
      filterToggle.addEventListener('click', function() {
        if (filterSidebar.getAttribute('data-open') === '1') {
          closeFilters();
        } else {
          openFilters();
        }
      });
    }
    if (filterCloseBtn) filterCloseBtn.addEventListener('click', closeFilters);
    if (filterBackdrop) filterBackdrop.addEventListener('click', closeFilters);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && filterSidebar && filterSidebar.getAttribute('data-open') === '1') {
        closeFilters();
      }
    });

    /* ─── Price range dual-thumb slider ────────────────────────── */
    var priceRanges = section.querySelectorAll('[data-price-range]');
    priceRanges.forEach(function(wrap) {
      var fromSlider = wrap.querySelector('[data-price-thumb="from"]');
      var toSlider = wrap.querySelector('[data-price-thumb="to"]');
      var fromInput = wrap.querySelector('[data-price-input="from"]');
      var toInput = wrap.querySelector('[data-price-input="to"]');
      var fill = wrap.querySelector('[data-price-fill]');
      if (!fromSlider || !toSlider) return;

      var min = parseFloat(wrap.dataset.priceMin) || 0;
      var max = parseFloat(wrap.dataset.priceMax) || 100;

      function updateFill() {
        var fromVal = parseFloat(fromSlider.value);
        var toVal = parseFloat(toSlider.value);
        if (fromVal > toVal) {
          // swap if crossed
          var tmp = fromVal; fromVal = toVal; toVal = tmp;
          fromSlider.value = fromVal;
          toSlider.value = toVal;
        }
        var pctFrom = ((fromVal - min) / (max - min)) * 100;
        var pctTo = ((toVal - min) / (max - min)) * 100;
        if (fill) {
          fill.style.left = pctFrom + '%';
          fill.style.right = (100 - pctTo) + '%';
        }
      }

      function syncInputsFromSliders() {
        if (fromInput) fromInput.value = parseFloat(fromSlider.value) === min ? '' : fromSlider.value;
        if (toInput) toInput.value = parseFloat(toSlider.value) === max ? '' : toSlider.value;
      }
      function syncSlidersFromInputs() {
        var fromVal = fromInput && fromInput.value !== '' ? parseFloat(fromInput.value) : min;
        var toVal = toInput && toInput.value !== '' ? parseFloat(toInput.value) : max;
        if (isNaN(fromVal)) fromVal = min;
        if (isNaN(toVal)) toVal = max;
        fromVal = Math.max(min, Math.min(max, fromVal));
        toVal = Math.max(min, Math.min(max, toVal));
        fromSlider.value = fromVal;
        toSlider.value = toVal;
        updateFill();
      }

      fromSlider.addEventListener('input', function() { updateFill(); syncInputsFromSliders(); });
      toSlider.addEventListener('input', function() { updateFill(); syncInputsFromSliders(); });
      fromSlider.addEventListener('change', function() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(submitFilterForm, 400);
      });
      toSlider.addEventListener('change', function() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(submitFilterForm, 400);
      });
      if (fromInput) {
        fromInput.addEventListener('change', function() {
          syncSlidersFromInputs();
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(submitFilterForm, 400);
        });
      }
      if (toInput) {
        toInput.addEventListener('change', function() {
          syncSlidersFromInputs();
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(submitFilterForm, 400);
        });
      }

      updateFill();
    });

    /* ─── Mobile padding override (optional) ───────────────────── */
    function applyMobilePadding() {
      var top = section.dataset.mobilePadTop;
      var bot = section.dataset.mobilePadBottom;
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      if (!isMobile || (!top && !bot)) {
        section.style.removeProperty('padding-top');
        section.style.removeProperty('padding-bottom');
        return;
      }
      if (top) section.style.paddingTop = top + 'px';
      if (bot) section.style.paddingBottom = bot + 'px';
    }
    applyMobilePadding();
    window.addEventListener('resize', applyMobilePadding, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-addresses"]) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-customer-section="addresses"]');
    if (!section) return;

    section.querySelectorAll('[data-address-toggle-new]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var form = section.querySelector('[data-new-address-form]');
        if (form) form.hidden = !form.hidden;
      });
    });

    section.querySelectorAll('[data-address-edit]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var id = btn.dataset.addressEdit;
        var form = section.querySelector('[data-address-edit-form="' + id + '"]');
        if (form) form.hidden = false;
      });
    });

    section.querySelectorAll('[data-address-edit-cancel]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var id = btn.dataset.addressEditCancel;
        var form = section.querySelector('[data-address-edit-form="' + id + '"]');
        if (form) form.hidden = true;
      });
    });

    section.querySelectorAll('[data-address-delete]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (window.confirm(btn.dataset.confirm)) {
          if (window.Shopify && Shopify.postLink) {
            Shopify.postLink('/account/addresses/' + btn.dataset.addressDelete, { parameters: { _method: 'delete' } });
          }
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-login"]) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-customer-section="login"]');
    if (!section) return;
    var toggleBtn = section.querySelector('[data-recover-toggle]');
    var cancelBtn = section.querySelector('[data-recover-cancel]');
    var recoverForm = section.querySelector('[data-recover-form]');
    if (toggleBtn && recoverForm) {
      toggleBtn.addEventListener('click', function(e) { e.preventDefault(); recoverForm.hidden = false; recoverForm.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); });
    }
    if (cancelBtn && recoverForm) {
      cancelBtn.addEventListener('click', function(e) { e.preventDefault(); recoverForm.hidden = true; });
    }
    if (window.location.hash === '#recover' && recoverForm) { recoverForm.hidden = false; }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-card-main"]) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-gift-card-section]');
    if (!section) return;
    var codeEl = section.querySelector('[data-gift-code]');
    if (codeEl) {
      codeEl.addEventListener('click', function() {
        var code = codeEl.textContent.replace(/\s+/g, ' ').trim();
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(code).then(function() {
            var original = codeEl.textContent;
            codeEl.classList.add('ne-gc__code--copied');
            codeEl.textContent = 'Copied!';
            setTimeout(function() {
              codeEl.textContent = original;
              codeEl.classList.remove('ne-gc__code--copied');
            }, 1800);
          }).catch(function(){});
        } else {
          var range = document.createRange();
          range.selectNode(codeEl);
          window.getSelection().removeAllRanges();
          window.getSelection().addRange(range);
          try { document.execCommand('copy'); } catch(e) {}
        }
      });
    }
    var printBtn = section.querySelector('[data-gift-print]');
    if (printBtn) {
      printBtn.addEventListener('click', function() { window.print(); });
    }

    /* Render the gift-card QR (≥120×120px) from gift_card.qr_identifier once the
       deferred qrcode lib has loaded. Polls briefly since the script is deferred. */
    var qrEl = section.querySelector('[data-gift-card-qr]');
    if (qrEl && qrEl.dataset.identifier) {
      var tries = 0;
      var poll = setInterval(function () {
        if (window.QRCode) {
          clearInterval(poll);
          try {
            new window.QRCode(qrEl, {
              text: qrEl.dataset.identifier,
              width: 144,
              height: 144,
              colorDark: '#000000',
              colorLight: '#ffffff',
              correctLevel: window.QRCode.CorrectLevel.M
            });
          } catch (e) { /* noop */ }
        } else if (++tries > 50) {
          clearInterval(poll);
        }
      }, 100);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Desktop dropdown — JS-enhanced hover (supplement to CSS :hover fallback)
  // Uses is-open class + 80ms mouseleave delay to prevent premature close
  // when moving diagonally from nav-link to dropdown.
  function initDropdowns() {
    document.querySelectorAll('.ne-header__nav-item--has-dropdown').forEach(function(item) {
      if (item.dataset.dropdownInit) return; // prevent duplicate listeners
      item.dataset.dropdownInit = '1';
      var t;
      item.addEventListener('mouseenter', function() {
        clearTimeout(t);
        item.classList.add('is-open');
        var a = item.querySelector('[aria-expanded]');
        if (a) a.setAttribute('aria-expanded', 'true');
      });
      item.addEventListener('mouseleave', function() {
        t = setTimeout(function() {
          item.classList.remove('is-open');
          var a = item.querySelector('[aria-expanded]');
          if (a) a.setAttribute('aria-expanded', 'false');
        }, 80);
      });
      // Keyboard: the CSS opens the dropdown on :focus-within, so keep
      // aria-expanded in sync when focus enters/leaves the nav item (WCAG 4.1.2).
      item.addEventListener('focusin', function() {
        clearTimeout(t);
        item.classList.add('is-open');
        var a = item.querySelector('[aria-expanded]');
        if (a) a.setAttribute('aria-expanded', 'true');
      });
      item.addEventListener('focusout', function(e) {
        if (item.contains(e.relatedTarget)) return; // focus still inside
        item.classList.remove('is-open');
        var a = item.querySelector('[aria-expanded]');
        if (a) a.setAttribute('aria-expanded', 'false');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', initDropdowns);
  document.addEventListener('shopify:section:load', initDropdowns);

  // Floating tooltip for icon-mode nav — follows mouse, anchor depends on header position
  function initIconTooltip() {
    var tooltip = document.getElementById('ne-header-icon-tooltip');
    if (!tooltip) {
      tooltip = document.createElement('div');
      tooltip.id = 'ne-header-icon-tooltip';
      tooltip.className = 'ne-header__icon-tooltip';
      tooltip.setAttribute('aria-hidden', 'true');
      document.body.appendChild(tooltip);
    }
    document.querySelectorAll('.ne-header__nav-icon-item').forEach(function(item) {
      if (item.dataset.tooltipInit) return;
      item.dataset.tooltipInit = '1';
      // Scope tooltip events to the icon-link only (not the whole item).
      // If attached to the item, hovering a dropdown/submenu descendant keeps
      // the tooltip visible — and the text ("Categories") redundantly overlays
      // the submenu items that already show their own labels.
      var link = item.querySelector('.ne-header__nav-icon-link');
      if (!link) return;
      var header = item.closest('.ne-header');
      var anchorX = '-50%';
      if (header) {
        if (header.classList.contains('ne-header--left')) anchorX = '0';
        else if (header.classList.contains('ne-header--right')) anchorX = '-100%';
      }
      var labelEl = item.querySelector('.ne-header__nav-icon-label');
      var text = labelEl ? labelEl.textContent.trim() : (link.getAttribute('aria-label') || '');
      if (!text) return;
      link.addEventListener('mouseenter', function() {
        tooltip.textContent = text;
        tooltip.style.setProperty('--ne-tt-anchor-x', anchorX);
        tooltip.classList.add('is-visible');
      });
      link.addEventListener('mousemove', function(e) {
        tooltip.style.setProperty('--ne-tt-x', e.clientX + 'px');
        tooltip.style.setProperty('--ne-tt-y', e.clientY + 'px');
      });
      link.addEventListener('mouseleave', function() {
        tooltip.classList.remove('is-visible');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', initIconTooltip);
  document.addEventListener('shopify:section:load', initIconTooltip);

  // Mobile / burger menu toggle — re-bindable on Customizer section reloads
  function initMobileMenu() {
    var mobileToggle = document.querySelector('.ne-header__mobile-toggle');
    var mobileMenu = document.getElementById('mobile-menu');
    if (!mobileToggle || !mobileMenu) return;
    if (mobileToggle.dataset.mobileMenuBound === '1') return;
    mobileToggle.dataset.mobileMenuBound = '1';

    var mobileClose = mobileMenu.querySelector('.ne-mobile-menu__close');

    // Drawer↔frame weld: while the drawer is open, tag the body so the frame's
    // edge on the drawer's side slides inward (CSS reads --ne-drawer-edge = the
    // drawer's inner-edge inset). offsetWidth is used (not getBoundingClientRect)
    // so the resting inner edge is measured even mid slide-in transform.
    var weldCloseTimer = null;

    function applyDrawerWeld() {
      if (weldCloseTimer) { clearTimeout(weldCloseTimer); weldCloseTimer = null; }
      if (!mobileMenu.classList.contains('ne-mobile-menu--frame-weld')) return;
      var isLeft = mobileMenu.classList.contains('ne-mobile-menu--from-left');
      var root = document.documentElement;
      // Lockstep slide: --ne-drawer-w = the drawer's resting width; --ne-drawer-edge
      // animates 0→w (open) / w→0 (close) and drives BOTH the drawer transform and
      // the frame edge (see header-styles-2.liquid @property --ne-drawer-edge).
      // offsetWidth is transform-independent (measures the resting box).
      var w = Math.max(0, Math.round(mobileMenu.offsetWidth));
      root.style.setProperty('--ne-drawer-w', w + 'px');
      root.style.setProperty('--ne-drawer-edge', '0px'); // start off-screen (no transition from equal value)
      // Real header bottom — --ne-header-height is not reliably on :root, so measure
      // the header directly and align the drawer top (+ backdrop top) to it.
      var hdr = document.querySelector('.ne-header');
      if (hdr) root.style.setProperty('--ne-drawer-top', Math.max(0, Math.round(hdr.getBoundingClientRect().bottom)) + 'px');
      // Match the dimmed backdrop to the frame's REAL mulde so no undimmed strip
      // shows and its corners round like the frame (::backdrop inherits these :root
      // vars). Frame inset = its bottom gap (uniform + shift-independent); radius
      // from its computed corner. Baked Liquid fallbacks cover non-inheriting UAs.
      var frameEl = document.querySelector('.ne-layer-frame');
      if (frameEl) {
        var fr = frameEl.getBoundingClientRect();
        root.style.setProperty('--ne-drawer-frame-inset', Math.max(0, Math.round(window.innerHeight - fr.bottom)) + 'px');
        root.style.setProperty('--ne-drawer-frame-radius', getComputedStyle(frameEl).borderTopLeftRadius);
      }
      var cl = document.body.classList;
      cl.add('ne-drawer-open', isLeft ? 'ne-drawer-open--left' : 'ne-drawer-open--right');
      if (mobileMenu.classList.contains('ne-mobile-menu--frame-push')) cl.add('ne-drawer-open--push');
      // One frame later (so the edge:0 start commits first), animate edge → full
      // width: drawer slides in AND the frame edge tracks it in perfect lockstep.
      // Same frame: fade the backdrop dim in (grows with the drawer, no dark pop).
      requestAnimationFrame(function () {
        root.style.setProperty('--ne-drawer-edge', w + 'px');
        mobileMenu.classList.add('ne-drawer-dimmed');
      });
    }

    function drawerSpeed() {
      // Slide duration — drawer_slide_speed (--ne-drawer-speed), with the nav dropdown
      // speed as legacy fallback. Must match the :root --ne-drawer-edge transition.
      var cs = getComputedStyle(document.documentElement);
      return parseFloat(cs.getPropertyValue('--ne-drawer-speed')) ||
             parseFloat(cs.getPropertyValue('--ne-dropdown-speed')) || 280;
    }

    function finalizeClose() {
      var body = document.body, root = document.documentElement;
      body.classList.remove('ne-drawer-open', 'ne-drawer-open--left', 'ne-drawer-open--right', 'ne-drawer-open--push');
      ['--ne-drawer-edge', '--ne-drawer-w', '--ne-drawer-top', '--ne-drawer-frame-inset', '--ne-drawer-frame-radius'].forEach(function (p) { root.style.removeProperty(p); });
      mobileMenu.classList.remove('ne-drawer-dimmed');
      mobileMenu.style.transform = '';
    }

    var closing = false;
    function requestClose() {
      if (closing) return;
      if (!mobileMenu.open && !mobileMenu.hasAttribute('open')) return;
      closing = true;
      mobileToggle.setAttribute('aria-expanded', 'false');
      // Fade the dim back out over the slide (mirror of the open fade-in).
      mobileMenu.classList.remove('ne-drawer-dimmed');
      if (mobileMenu.classList.contains('ne-mobile-menu--frame-weld')) {
        // Weld: animate edge → 0. Drawer transform + frame edge track it in
        // lockstep (KEEP the body classes so the frame `right/left: max(..,edge)`
        // rule stays live and retreats glued to the drawer — removing them would
        // snap the frame back instantly and expose the fill as a panel). Classes
        // + vars are cleared in finalizeClose, after the drawer is off-screen.
        document.documentElement.style.setProperty('--ne-drawer-edge', '0px');
      } else {
        // Non-weld drawer: explicit inline slide-out (native allow-discrete exit
        // was unreliable). No frame involved.
        var isLeft = mobileMenu.classList.contains('ne-mobile-menu--from-left');
        mobileMenu.style.transform = 'translateX(' + (isLeft ? '-100%' : '100%') + ')';
      }
      if (weldCloseTimer) clearTimeout(weldCloseTimer);
      weldCloseTimer = setTimeout(function () {
        mobileMenu.close();   // now off-screen → the display:none is invisible
        finalizeClose();
        closing = false;
        weldCloseTimer = null;
      }, drawerSpeed() + 20); // +20ms buffer so the slide finishes before we hide
    }

    mobileToggle.addEventListener('click', function () {
      // Toggle: a second click on the burger closes the open drawer.
      if (mobileMenu.open || mobileMenu.hasAttribute('open')) { requestClose(); return; }
      if (typeof mobileMenu.showModal === 'function') {
        mobileMenu.showModal();
      } else {
        mobileMenu.setAttribute('open', '');
      }
      mobileToggle.setAttribute('aria-expanded', 'true');
      applyDrawerWeld();
    });
    if (mobileClose) {
      mobileClose.addEventListener('click', function () { requestClose(); });
    }
    mobileMenu.addEventListener('click', function (e) {
      // Backdrop click, OR the weld-mode header catcher over the (inert) burger.
      var onCatch = e.target.closest && e.target.closest('[data-ne-drawer-dismiss]');
      var onBackdrop = e.target === mobileMenu;
      if (!onCatch && !onBackdrop) return;
      // The header cart icon sits OUTSIDE the modal dialog → it is inert while the
      // menu is open, and it's covered by the ::backdrop (non-weld) or the header
      // catcher (weld), so a direct click can never reach it. If the dismiss click
      // landed over the cart icon, hand off: close the menu, then open the cart.
      var openCart = false;
      var cartTrigger = document.querySelector('.ne-header__cart, [data-cart-trigger]');
      if (cartTrigger && (e.clientX || e.clientY)) {
        var r = cartTrigger.getBoundingClientRect();
        if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) {
          openCart = true;
        }
      }
      requestClose();
      if (openCart) {
        // Open after the close finishes (finalizeClose restores body scroll-lock at
        // drawerSpeed()+20) so the two overlays don't fight over scroll-lock/focus.
        setTimeout(function () {
          if (window.NECart && typeof window.NECart.open === 'function') window.NECart.open();
        }, drawerSpeed() + 30);
      }
    });
    // ESC (native dialog cancel) → animate out instead of the instant native close.
    mobileMenu.addEventListener('cancel', function (e) { e.preventDefault(); requestClose(); });
    mobileMenu.addEventListener('close', function () {
      // Safety net if the dialog is closed by a path that bypassed requestClose.
      mobileToggle.setAttribute('aria-expanded', 'false');
      if (!closing) finalizeClose();
    });
  }
  document.addEventListener('DOMContentLoaded', initMobileMenu);
  document.addEventListener('shopify:section:load', initMobileMenu);

  // Locale selector — click-to-open popover + ISO-code to emoji-flag conversion.
  // Regional Indicator Symbols: 0x1F1E6 + (charCode - 'A') per letter.
  function isoToFlagEmoji(iso) {
    if (!iso || iso.length !== 2) return '';
    var A = 0x41, BASE = 0x1F1E6;
    var cc = iso.toUpperCase();
    return String.fromCodePoint(BASE + cc.charCodeAt(0) - A) +
           String.fromCodePoint(BASE + cc.charCodeAt(1) - A);
  }

  // Sidebar + menu-merge: the panel is position:fixed and slides out from behind the
  // bar (like the nav dropdowns), so it needs a y-anchor. Centre it on the button, then
  // clamp into the frame-safe band → a low (actions-bottom) button opens UPWARD, a high
  // one downward — mirrors updateSidebarFlip's place() for the nav mega-panel. Top
  // headers keep the CSS top:100% (no JS needed).
  function placeLocalePanel(root) {
    var header = root.closest('.ne-header');
    if (!header || !header.classList.contains('ne-header--menu-merge')) return;
    var toggle = root.querySelector('.ne-header__locale-toggle');
    var panel = root.querySelector('.ne-header__locale-panel');
    if (!toggle || !panel) return;
    if (!/ne-header--(left|right)\b/.test(header.className)) {
      // TOP: right-align the fixed panel to the button's right edge (header-bottom
      // anchoring is handled in CSS via --ne-header-bottom). Then publish the panel's
      // measured L/R edges so the weld bracket lands on its real corners.
      root.style.setProperty('--ne-loc-dd-right', Math.round(window.innerWidth - toggle.getBoundingClientRect().right) + 'px');
      requestAnimationFrame(function () {
        var pr = panel.getBoundingClientRect();
        root.style.setProperty('--ne-loc-bracket-left', Math.round(pr.left) + 'px');
        root.style.setProperty('--ne-loc-bracket-right', Math.round(window.innerWidth - pr.right) + 'px');
      });
      return;
    }
    var vh = Math.min(
      window.innerHeight || Infinity,
      (window.visualViewport && window.visualViewport.height) || Infinity,
      document.documentElement.clientHeight || Infinity
    );
    if (!isFinite(vh)) vh = window.innerHeight || 800;
    var cs = getComputedStyle(document.documentElement);
    var px = function (n) { return parseFloat(cs.getPropertyValue(n)) || 0; };
    var foff = px('--ne-frame-offset') || 8;
    var bandTop = foff + px('--ne-frame-padding-top') + 2;
    var bandBottom = vh - foff - px('--ne-frame-padding-bottom') - 2;
    var place = function () {
      var tr = toggle.getBoundingClientRect();
      var mid = tr.top + tr.height / 2;
      var avail = Math.max(0, bandBottom - bandTop);
      var ph = Math.min(panel.offsetHeight || 0, avail);
      var top = Math.min(Math.max(bandTop, mid - ph / 2), bandBottom - ph);
      root.style.setProperty('--ne-loc-dd-top', Math.round(top) + 'px');
      root.style.setProperty('--ne-loc-dd-height', Math.round(ph) + 'px');
    };
    place();
    requestAnimationFrame(function () { requestAnimationFrame(place); });
  }

  function initLocaleSelector() {
    document.querySelectorAll('[data-ne-locale]').forEach(function (root) {
      // Paint flag (Liquid can't compute Unicode math)
      var flagEl = root.querySelector('[data-ne-locale-flag]');
      if (flagEl) flagEl.textContent = isoToFlagEmoji(flagEl.getAttribute('data-ne-locale-flag'));

      var toggle = root.querySelector('.ne-header__locale-toggle');
      if (!toggle || toggle.dataset.neLocaleBound === '1') return;
      toggle.dataset.neLocaleBound = '1';

      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = root.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (isOpen) placeLocalePanel(root);
      });
    });

    // Single document-level handlers (idempotent via _ne flag)
    if (!document._neLocaleBound) {
      document._neLocaleBound = true;
      document.addEventListener('click', function (e) {
        document.querySelectorAll('[data-ne-locale].is-open').forEach(function (root) {
          if (!root.contains(e.target)) {
            root.classList.remove('is-open');
            var t = root.querySelector('.ne-header__locale-toggle');
            if (t) t.setAttribute('aria-expanded', 'false');
          }
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        document.querySelectorAll('[data-ne-locale].is-open').forEach(function (root) {
          root.classList.remove('is-open');
          var t = root.querySelector('.ne-header__locale-toggle');
          if (t) { t.setAttribute('aria-expanded', 'false'); t.focus(); }
        });
      });
    }
  }
  document.addEventListener('DOMContentLoaded', initLocaleSelector);
  document.addEventListener('shopify:section:load', initLocaleSelector);

  // Sidebar dropdown viewport-flip — when a nav-item sits in the lower third
  // of the viewport, anchor its dropdown by the bottom edge so it opens upward
  // (OS-style). Near the top, anchor by the top edge. Otherwise use the
  // default vertical-center.
  function updateSidebarFlip(item) {
    if (!item) return;
    var rect = item.getBoundingClientRect();
    // Smallest of the available height measures = closest to the VISIBLE area.
    // The Customizer preview iframe inflates window.innerHeight to the full page
    // height, which would let a fixed panel run past the visible bottom; the
    // visual viewport / clientHeight track the visible box better.
    var vh = Math.min(
      window.innerHeight || Infinity,
      (window.visualViewport && window.visualViewport.height) || Infinity,
      document.documentElement.clientHeight || Infinity
    );
    if (!isFinite(vh)) vh = window.innerHeight || 800;
    var mid = rect.top + rect.height / 2;
    var header = item.closest('.ne-header');
    // Panel-style sidebar mega: the mega is position:fixed. Place it vertically
    // CENTERED on the hovered item, but CLAMP it into the frame-safe band so it
    // never overflows the viewport — only then does it shift to the top/bottom
    // edge. This replaces the flip-class approach for the panel variant.
    if (header && header.classList.contains('ne-header--sb-mega-panel')) {
      var panel = item.querySelector('.ne-header__megamenu');
      if (panel) {
        // Frame-safe band from the VIEWPORT + frame CSS vars (robust — the frame
        // element's rect is unreliable inside the Customizer iframe).
        var cs = getComputedStyle(document.documentElement);
        var px = function (n) { return parseFloat(cs.getPropertyValue(n)) || 0; };
        var foff = px('--ne-frame-offset') || 8;
        var bandTop = foff + px('--ne-frame-padding-top') + 2;
        var bandBottom = vh - foff - px('--ne-frame-padding-bottom') - 2;
        var place = function () {
          var avail = Math.max(0, bandBottom - bandTop);
          var ph = Math.min(panel.offsetHeight || 0, avail);
          // Center on the item, then clamp INTO the band → docks at whichever
          // edge the overflow occurs (bottom item → bottom edge, opens upward).
          var top = Math.min(Math.max(bandTop, mid - ph / 2), bandBottom - ph);
          top = Math.round(top);
          panel.style.top = top + 'px';
          panel.style.bottom = 'auto';
          // Clamp the height to the MEASURED band (not CSS 100vh) so the panel
          // scrolls when content overflows — the Customizer iframe reports a
          // 100vh larger than the visible preview, so the CSS cap alone let the
          // content spill past the panel without scrolling.
          panel.style.maxHeight = Math.max(0, bandBottom - top) + 'px';
        };
        place();
        // Re-measure once layout/opacity settles (product images, max-height).
        requestAnimationFrame(function () { requestAnimationFrame(place); });
      }
      return;
    }
    item.classList.remove('ne-header__nav-item--flip-top');
    item.classList.remove('ne-header__nav-item--flip-v');
    if (mid > vh * 0.66) {
      item.classList.add('ne-header__nav-item--flip-v');
    } else if (mid < vh * 0.20) {
      item.classList.add('ne-header__nav-item--flip-top');
    }
  }
  function initSidebarFlip() {
    var headers = document.querySelectorAll('.ne-header--left, .ne-header--right');
    headers.forEach(function (h) {
      if (h.dataset.flipDelegated === '1') return;
      h.dataset.flipDelegated = '1';
      // Delegate on the header so dynamically-created items (the synthetic "More"
      // overflow menu, re-synthesized megas) are covered without needing a
      // re-bind — the earlier per-item binding missed items created after init,
      // which fell back to the CSS `top` (always docked at the top edge).
      var onEnter = function (e) {
        var item = e.target.closest('.ne-header__nav-item--has-dropdown, .ne-header__nav-item--has-megamenu');
        if (!item || !h.contains(item)) return;
        if (h._neFlipItem === item) return; // don't re-run on every mousemove
        h._neFlipItem = item;
        updateSidebarFlip(item);
      };
      h.addEventListener('mouseover', onEnter);
      h.addEventListener('focusin', onEnter);
      h.addEventListener('mouseleave', function () { h._neFlipItem = null; });
    });
  }
  document.addEventListener('DOMContentLoaded', initSidebarFlip);
  document.addEventListener('shopify:section:load', initSidebarFlip);
  window.addEventListener('resize', function () {
    var open = document.querySelectorAll('.ne-header--left .ne-header__nav-item--has-dropdown:hover, .ne-header--right .ne-header__nav-item--has-dropdown:hover');
    open.forEach(updateSidebarFlip);
  });

  // Unified scroll handler: handles smart-sticky hide/show AND scrolled-state
  // toggle for initial-transparent + initial-hidden headers. Query the header
  // fresh on every tick so Customizer re-renders (which replace the DOM node)
  // don't leave the listener pointing at a stale element.
  if (!window.__neHeaderScrollBound) {
    window.__neHeaderScrollBound = true;
    var _neLastScroll = 0;
    var _neTicking = false;
    var _neMouthHidden = false; // frame-mouth smart-hide state (direction-aware reveal)
    var _neLetzterMouthShift = null; // zuletzt auf :root geschriebener --ne-mouth-shift (Rule 533)
    /* Derselbe Versatz wie `header.style.top`, aber als Custom Property — der
       VERSCHWEISSTE Header (ne-header--frame-weld) erzwingt `top: 0 !important`
       (header-styles.liquid ~629: er sitzt buendig auf der Rahmenkante), und
       das ueberstimmt den Inline-Stil. Steht eine Section UEBER ihm, verschwand
       sie deshalb unter dem Header, waehrend der Abstandshalter ihre Hoehe
       trotzdem reservierte: auf Pulse 39,1 px verdeckte Leiste plus 20 px
       Section-Abstand = 59 px Totstreifen (User 2026-07-30). Ueber die Variable
       kommt der Versatz an der !important-Regel vorbei — und die Rahmen-Mulde
       liest denselben Wert, damit sie in Deckung bleibt.
       ⚠️ Ohne Section ueber dem Header ist der Wert 0 und alles rechnet wie
       vorher; die Variable wird dann nie geschrieben. Rule 533: nur bei
       Wertaenderung schreiben. */
    var _neLetzterAboveShift = null;
    var _neSetzeAboveShift = function (header, px) {
      var wert = px + 'px';
      if (wert === _neLetzterAboveShift) return;
      /* Beim allerersten Aufruf mit 0 gar nichts schreiben — sonst traegt JEDE
         Seite eine :root-Eigenschaft, die sie nicht braucht. */
      if (_neLetzterAboveShift === null && px === 0) { _neLetzterAboveShift = wert; return; }
      _neLetzterAboveShift = wert;
      var root = document.documentElement;
      if (px === 0) root.style.removeProperty('--ne-header-above-shift');
      else root.style.setProperty('--ne-header-above-shift', wert);
      /* Solange der Versatz am Scrollen haengt, darf die Mulde ihn NICHT weich
         nachfahren — ihre 300-ms-Ueberblendung (sections/header.liquid ~630) ist
         fuer den Auf-/Abgang des Smart-Sticky gedacht und wuerde hier hinter dem
         Header herlaufen. Die Klasse wechselt nur an den zwei Umschaltpunkten. */
      root.classList.toggle('ne-above-follow', px > 0);
    };
    // Cumulative height of any sections placed ABOVE the header within the
    // header group (e.g. an announcement bar). A fixed top header pins to
    // top:0 and would overlap them, so we offset its `top` by this height
    // and let it follow-then-pin as those sections scroll away.
    var _neHeaderAboveH = 0;
    /* Hoehe der ERSTEN Section, gemessen ausserhalb des Scroll-Takts. Sie ist die
       Schwelle, ab der ein anfangs transparenter Header solide wird — und sie aendert
       sich beim Scrollen nicht. Frueher wurde sie in JEDEM Frame frisch gelesen, und
       zwar nach dem Setzen von `top` und Klassen, also mit erzwungener
       Stilneuberechnung. Aktualisiert wird sie dort, wo sie sich wirklich aendern
       kann: `load` (also nach den Bildern), `resize` und `shopify:section:load`. */
    var _neFirstSectionH = 0;
    var neMeasureHeaderAbove = function () {
      var h = document.querySelector('.ne-header');
      var _fs = document.querySelector('.ne-layer-content > .shopify-section');
      _neFirstSectionH = _fs ? (_fs.offsetHeight || 0) : 0;
      _neHeaderAboveH = 0;
      if (h) {
        var sec = h.closest('.shopify-section');
        var sib = sec ? sec.previousElementSibling : null;
        while (sib) {
          if (sib.classList && sib.classList.contains('shopify-section')) {
            _neHeaderAboveH += sib.offsetHeight || 0;
          }
          sib = sib.previousElementSibling;
        }
      }
      neHeaderScrollTick();
    };
    var neHeaderScrollTick = function () {
      _neTicking = false;
      var header = document.querySelector('.ne-header');
      if (!header) return;
      var y = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;

      /* ⚠️ ERST ALLES MESSEN, DANN SCHREIBEN (Rule 534). Vorher standen drei
         Lesezugriffe NACH dem Setzen von `top`, `transform` und Klassen; jeder davon
         zwingt den Browser, den Stil sofort neu zu rechnen, statt es bis zum naechsten
         Frame zu sammeln. In beiden Traces vom 30.07. war diese Funktion damit der
         groesste Einzelposten ueberhaupt — 283 bzw. 330 erzwungene Neuberechnungen mit
         462 bzw. 521 ms, also rund die Haelfte der gesamten erzwungenen Arbeit.
         ⚠️ Der Lesezugriff, der weiter unten STEHEN BLEIBT, ist das
         `getBoundingClientRect`: es muss die Position sehen, die `top` und `transform`
         in diesem Frame gerade gesetzt haben. Wuerde man es hierher ziehen, aendert
         sich das Verhalten (Aufklapp-Richtung und Kantenverlauf haengen daran). Aus
         vier erzwungenen Neuberechnungen pro Frame wird so eine. */
      /* ⚠️ NUR BEI BEDARF MESSEN, nicht vorsorglich. Erster Anlauf las die Hoehe
         unbedingt hier oben — richtig gedacht (vor den Schreibzugriffen), aber damit
         wurde sie in JEDEM Frame gelesen, auch wenn kein Zweig sie braucht. Auf einem
         Header ohne Pin-Bottom, ohne Frame-Mouth und ohne Anfangstransparenz wird sie
         NIE gebraucht — der erzwungene Lesezugriff war dort also nicht entfernt,
         sondern nur ausgetauscht (im Trace vom 30.07. weiterhin 350-558 Ereignisse).
         Jetzt liefert `_hh()` den Wert beim ersten Zugriff und merkt ihn sich fuer den
         Rest des Frames: hoechstens eine Messung, meistens keine. `_vhNow` bleibt
         unbedingt, `window.innerHeight` erzwingt kein Layout. */
      var _hCache = null;
      var _hh = function () {
        if (_hCache === null) _hCache = header.offsetHeight || 70;
        return _hCache;
      };
      var _vhNow = window.innerHeight || document.documentElement.clientHeight || 800;

      // Offset the header below above-header sections (announcement bar etc.)
      // and follow them up as the page scrolls, pinning at 0 once past them.
      // Only top-anchored fixed headers — floating/sidebar manage their own top.
      var _isTopFixed = (header.classList.contains('ne-header--sticky') || header.classList.contains('ne-header--sticky-smart')) && !header.classList.contains('ne-header--floating');
      if (_isTopFixed && _neHeaderAboveH > 0) {
        var _follow = _neHeaderAboveH - y;
        if (header.classList.contains('ne-header--pin-bottom')) {
          // Keep the header on-screen pinned to the viewport bottom until the
          // above-header section scrolls far enough that the header can rise to
          // the top (so a full-height hero above it never hides the header).
          _follow = Math.min(_follow, _vhNow - _hh());
        }
        var _oben = Math.max(0, _follow);
        header.style.top = _oben + 'px';
        _neSetzeAboveShift(header, _oben);
      } else {
        if (header.style.top) header.style.top = '';
        _neSetzeAboveShift(header, 0);
      }

      // Smart-sticky hide/show
      if (header.classList.contains('ne-header--sticky-smart')) {
        if (header.classList.contains('ne-header--frame-mouth')) {
          // Frame-mouth mode: DIRECTION-AWARE hide/show (reveal on scroll-up from anywhere,
          // not only at the top). The header slides fully up (−H) when hiding and back to 0
          // when showing; --ne-mouth-shift jumps in lockstep so the frame mouth follows. Both
          // the header transform and the frame-area top carry a matching 300ms transition
          // (added in the merge <style>) so the glued slide stays smooth. (Earlier this was
          // scroll-linked = position-only → the header stayed hidden for all y>H and only
          // reappeared near the very top; user wanted a normal reveal-on-scroll-up.)
          var _mH = _hh();
          if (y <= 0) _neMouthHidden = false;
          else if (y > _neLastScroll && y > 100) _neMouthHidden = true;   // scroll down → hide
          else if (y < _neLastScroll) _neMouthHidden = false;             // scroll up → show
          var _shift = _neMouthHidden ? _mH : 0;
          header.style.transform = 'translateY(' + (-_shift) + 'px)';
          /* ⚠️ Dieser Zweig laeuft in JEDEM Scroll-Frame, und ein `setProperty` auf
             `documentElement` entwertet den Stil des GANZEN Dokuments (Rule 533). Der
             Wert kennt aber nur zwei Zustaende (0 oder Headerhoehe) und aendert sich
             deshalb nur an den beiden Umschaltpunkten — ohne Vergleich wird derselbe
             Wert 60x pro Sekunde neu geschrieben. Gleiche Rechnung wie bei
             publishHeaderBottom (blocks/menu.liquid) und syncHeight oben. */
          var _shiftWert = _shift + 'px';
          if (_shiftWert !== _neLetzterMouthShift) {
            _neLetzterMouthShift = _shiftWert;
            document.documentElement.style.setProperty('--ne-mouth-shift', _shiftWert);
          }
          header.classList.remove('ne-header--hidden'); // inline transform handles it; avoid the CSS yank rule
        } else {
          // Clear any leftover scroll-linked inline transform (mode switched in Customizer).
          if (header.style.transform) header.style.transform = '';
          if (y <= 0) header.classList.remove('ne-header--hidden');
          else if (y > _neLastScroll && y > 100) header.classList.add('ne-header--hidden');
          else if (y < _neLastScroll) header.classList.remove('ne-header--hidden');
        }
      }

      // Scrolled-state toggle (transparent / hidden-until-scroll).
      // Threshold = bottom of the first (full-bleed hero / scroll-scrub) section
      // minus the header height, so the header stays transparent over the whole
      // hero and only turns solid (bg + shadow/glow, coupled together) once real
      // content scrolls under it. A fixed small threshold (50px) made the header
      // turn solid right at the top edge → the solid colour + shadow flashed
      // briefly during the smart-hide reveal / customizer auto-scroll near the
      // top (user 2026-05-26). Falls back to 60% viewport; min 50px.
      if (
        header.classList.contains('ne-header--initial-transparent') ||
        header.classList.contains('ne-header--initial-hidden')
      ) {
        var _hdrH = _hh();
        // Floor the threshold at 60% of the viewport so a SHORT first section
        // (mobile heroes render much lower than desktop → the header used to flip
        // solid far too early, user 2026-07-11) still keeps the header transparent
        // for ~half a screen. A tall desktop hero exceeds the floor → unchanged.
        var _floor = Math.round(_vhNow * 0.6);
        var _solidAt = _neFirstSectionH > 0
          ? Math.max(_neFirstSectionH - _hdrH, _floor)
          : _floor;
        if (y > _solidAt) header.classList.add('ne-header--scrolled');
        else header.classList.remove('ne-header--scrolled');
      }

      // Mirror transparent-on-top state to body so frame fade-in/out
      // can be a simple descendant rule (body :has() with class-toggle
      // on a descendant proved unreliable for triggering CSS transitions
      // on great-grandchildren — the body-class approach animates clean).
      var isTransparentTop =
        header.classList.contains('ne-header--initial-transparent') &&
        !header.classList.contains('ne-header--scrolled');
      document.body.classList.toggle('ne-frame-suppressed', isTransparentTop);

      // Open-up flip: when the header sits low in the viewport (a section
      // placed ABOVE it in the header group pushes it down until it scrolls
      // up to pin) there's no room below for a dropdown, so flip it to open
      // UPWARD. Reverts to open-down as the header rises to the top. Sidebar
      // headers (top ≈ 0, bottom ≈ vh) never match (above is not > below).
      /* ⚠️ Dies ist der EINZIGE erzwungene Lesezugriff, der pro Frame uebrig bleibt —
         und er zahlt fuer FREMDE Schreibzugriffe: die Scroll-Effekte setzen kurz davor
         `--ne-scroll-*` auf ihren Elementen, damit ist der Stil schmutzig, und diese
         Messung erzwingt die Neuberechnung sofort. In der Sonde vom 30.07. waren 22
         von 65 erzwungenen Neuberechnungen genau diese Reihenfolge.
         Er hat nur ZWEI Verbraucher, und beide koennen inaktiv sein:
           · die Aufklapp-Richtung braucht `_r.top > _spaceBelow`, also einen Header,
             der ueberhaupt nach unten geschoben ist. Das passiert nur, wenn Sections
             ueber ihm stehen (_neHeaderAboveH > 0) oder er schwebt. Sonst ist `top`
             hoechstens 0 und die Bedingung per Konstruktion falsch.
           · der weiche Kantenverlauf laeuft nur mit eigener Klasse.
         Trifft keins von beidem zu, wird nichts gemessen. Auf 21rebel (seitlicher
         Header, keine Section darueber, Kantenverlauf aus) faellt der Lesezugriff
         damit vollstaendig weg. */
      var _kannOpenUp = _neHeaderAboveH > 0 || header.classList.contains('ne-header--floating');
      var _weicheKante = header.classList.contains('ne-header--soft-edge-autofade');
      if (!_kannOpenUp && !_weicheKante) {
        header.classList.remove('ne-header--open-up');
        header.style.removeProperty('--ne-sea-top');
        header.style.removeProperty('--ne-sea-bottom');
        _neLastScroll = y;
        return;
      }
      var _r = header.getBoundingClientRect();
      var _vh = _vhNow;
      var _spaceBelow = _vh - _r.bottom;
      var _spaceAbove = _r.top;
      // open-up flips low headers' dropdowns up AND (in radial) lifts the arc so
      // points stay on-screen. Radial keeps its dropdown opening DOWN via a CSS
      // override so the menu doesn't cover its own point.
      if (_spaceBelow < 240 && _spaceAbove > _spaceBelow) header.classList.add('ne-header--open-up');
      else header.classList.remove('ne-header--open-up');

      // Soft-edge auto-fade: ramp each edge's fade size continuously toward 0
      // as that edge nears the screen edge (a fade into the screen edge is
      // pointless), so the swap is smooth instead of a hard switch. Off → CSS
      // keeps both edges at their full set sizes.
      if (header.classList.contains('ne-header--soft-edge-autofade')) {
        var _ramp = 140;
        var _topSize = parseFloat(header.getAttribute('data-soft-top-size')) || 0;
        var _botSize = parseFloat(header.getAttribute('data-soft-bottom-size')) || 0;
        var _topF = Math.max(0, Math.min(1, _r.top / _ramp));
        var _botF = Math.max(0, Math.min(1, (_vh - _r.bottom) / _ramp));
        header.style.setProperty('--ne-sea-top', (_topSize * _topF) + 'px');
        header.style.setProperty('--ne-sea-bottom', (_botSize * _botF) + 'px');
      } else {
        header.style.removeProperty('--ne-sea-top');
        header.style.removeProperty('--ne-sea-bottom');
      }

      _neLastScroll = y;
    };
    var neHeaderScrollHandler = function () {
      if (_neTicking) return;
      _neTicking = true;
      window.requestAnimationFrame(neHeaderScrollTick);
    };
    window.addEventListener('scroll', neHeaderScrollHandler, { passive: true });
    // Re-measure the above-header height (and re-settle the scrolled state)
    // on load, resize, late asset load, and Customizer section reload — any
    // of which can change the announcement-bar height above the header.
    window.addEventListener('resize', neMeasureHeaderAbove, { passive: true });
    window.addEventListener('load', neMeasureHeaderAbove);
    document.addEventListener('shopify:section:load', neMeasureHeaderAbove);
    neMeasureHeaderAbove();
  }

  // Hidden-until-hover reveal: when the cursor nears the top of the screen,
  // reveal the (otherwise hidden) nav even before it reaches the header. The
  // CSS already reveals on :hover / :focus-within; this adds the "approach
  // from anywhere near the top" cue. Mouse/pen only — touch falls back to the
  // burger drawer, keyboard uses :focus-within. Top/floating headers only;
  // sidebar headers rely on the CSS :hover (a top-zone makes no sense there).
  if (!window.__neHeaderRevealBound) {
    window.__neHeaderRevealBound = true;
    var _neRevealTick = false;
    var _neRevealY = -1;
    var neClearReveal = function () {
      var h = document.querySelector('.ne-header--nav-hidden');
      if (h) h.classList.remove('ne-header--nav-revealed');
    };
    var neRevealApply = function () {
      _neRevealTick = false;
      var header = document.querySelector('.ne-header--nav-hidden');
      if (!header) return;
      var pos = header.getAttribute('data-header-position') || 'top';
      if (pos === 'left' || pos === 'right') { header.classList.remove('ne-header--nav-revealed'); return; }
      if (_neRevealY < 0) { header.classList.remove('ne-header--nav-revealed'); return; }
      var rect = header.getBoundingClientRect();
      // Reveal only when the cursor is within a band around the header's ACTUAL
      // position — works whether the header is at the top or pinned to the
      // bottom. (A fixed "near the top of the screen" zone became the whole
      // viewport for a bottom-pinned header, revealing the nav on any move.)
      if (_neRevealY >= rect.top - 80 && _neRevealY <= rect.bottom + 80) header.classList.add('ne-header--nav-revealed');
      else header.classList.remove('ne-header--nav-revealed');
    };
    window.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch') return;
      if (!document.querySelector('.ne-header--nav-hidden')) return;
      _neRevealY = e.clientY;
      if (_neRevealTick) return;
      _neRevealTick = true;
      window.requestAnimationFrame(neRevealApply);
    }, { passive: true });
    document.documentElement.addEventListener('mouseleave', function () {
      _neRevealY = -1;
      neClearReveal();
    });
  }

  // Icon-Pairing Preview visibility — overlay rendering itself lives in
  // blocks/menu.liquid; this shim only toggles the `.is-active` class when
  // the header section or one of its blocks is selected in the Customizer.
  function setIconPairingVisible(visible) {
    var root = document.querySelector('[data-ne-icon-pairing-preview]');
    if (!root) return;
    root.classList.toggle('is-active', !!visible);
  }

  function isOwnHeaderEvent(e) {
    var root = document.querySelector('[data-ne-icon-pairing-preview]');
    if (!root || !e || !e.detail) return false;
    var sectionId = root.getAttribute('data-section-id');
    return e.detail.sectionId === sectionId;
  }

  function initIconPairingPreviewVisibility() {
    if (!window.Shopify || !window.Shopify.designMode) {
      setIconPairingVisible(true);
    }
  }

  document.addEventListener('DOMContentLoaded', initIconPairingPreviewVisibility);
  document.addEventListener('shopify:section:load', initIconPairingPreviewVisibility);
  document.addEventListener('shopify:section:select', function(e) {
    if (isOwnHeaderEvent(e)) setIconPairingVisible(true);
  });
  document.addEventListener('shopify:section:deselect', function(e) {
    if (isOwnHeaderEvent(e)) setIconPairingVisible(false);
  });
  document.addEventListener('shopify:block:select', function(e) {
    if (isOwnHeaderEvent(e)) setIconPairingVisible(true);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function isMobile() {
      // Width-based to match the CSS mobile fallback (also so the
      // customizer's mobile preview triggers the fallback even
      // though it doesn't change pointer/hover capabilities).
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function lazyLoadVideo(video) {
      var source = video.querySelector('source[data-src]');
      if (!source || video.src) return;
      source.src = source.dataset.src;
      video.load();
    }

    function setupSoundToggle(section, video) {
      var btn = section.querySelector('.ne-hv__sound-toggle');
      if (!btn) return;
      btn.addEventListener('click', function () {
        video.muted = !video.muted;
        btn.dataset.muted = video.muted ? '1' : '0';
        btn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      });
    }

    function setupAutoplay(section, video) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            lazyLoadVideo(video);
            video.play().catch(function () {});
            obs.disconnect();
          }
        });
      }, { threshold: 0.1 });
      obs.observe(section);
    }

    function setupClickToPlay(section, video) {
      var btn = section.querySelector('.ne-hv__play-btn');
      if (!btn) return;
      var showControls = section.dataset.showControls !== 'false';
      btn.addEventListener('click', function () {
        lazyLoadVideo(video);
        video.controls = showControls;
        video.play().then(function () {
          section.classList.add('ne-hv--playing');
        }).catch(function () {});
      });
      // Hide button when video starts playing (handles native play triggers too)
      video.addEventListener('play', function () {
        section.classList.add('ne-hv--playing');
      });
    }

    function setupEmbedClickToPlay(section, placeholder) {
      // External YT/Vimeo embed in click-to-play mode: replace the
      // placeholder div with an autoplay iframe on play-btn click. The
      // iframe doesn't exist before the click so YT/Vimeo can't preload
      // its own play-button UI on top of our poster. Honors audio_mode
      // (muted vs with-toggle) and enable_video_controls settings via
      // URL parameters at iframe creation time.
      var btn = section.querySelector('.ne-hv__play-btn');
      if (!btn || !placeholder) return;
      var audioMode = section.dataset.audioMode || 'muted';
      var showControls = section.dataset.showControls !== 'false';
      btn.addEventListener('click', function () {
        var provider = placeholder.dataset.embedProvider;
        var id = placeholder.dataset.embedId;
        if (!provider || !id) return;
        var iframe = document.createElement('iframe');
        iframe.className = 'ne-hv__video ne-hv__video--embed';
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'autoplay; encrypted-media');
        iframe.setAttribute('allowfullscreen', '');
        iframe.title = 'Hero video';
        if (provider === 'youtube') {
          var ytParams = 'autoplay=1&playsinline=1&modestbranding=1&rel=0';
          if (audioMode === 'muted') ytParams += '&mute=1';
          if (!showControls) ytParams += '&controls=0';
          iframe.src = 'https://www.youtube.com/embed/' + id + '?' + ytParams;
        } else {
          var vmParams = 'autoplay=1';
          if (audioMode === 'muted') vmParams += '&muted=1';
          if (!showControls) vmParams += '&controls=0';
          iframe.src = 'https://player.vimeo.com/video/' + id + '?' + vmParams;
        }
        placeholder.parentNode.replaceChild(iframe, placeholder);
        section.classList.add('ne-hv--playing');
      });
    }

    function setupEmbedCover(section) {
      // Autoplay-loop YT/Vimeo: hide the brief play-button UI iframes
      // show before autoplay engages. Fade the cover out after a short
      // delay (covers most network conditions for the autoplay handshake).
      var cover = section.querySelector('[data-embed-cover]');
      if (!cover) return;
      setTimeout(function () {
        cover.style.opacity = '0';
        setTimeout(function () {
          if (cover.parentNode) cover.parentNode.removeChild(cover);
        }, 700);
      }, 1500);
    }

    function setupScrollScrub(section, video) {
      // No mobile fallback. Stack mode + scrub on mobile uses a tall
      // section (sticky video for scrub + content in flow before/after
      // the sticky region) so scrub mechanics still work. iOS Safari
      // may stutter under touch-scroll inertia (known trade-off).
      var startTime = parseFloat(section.dataset.startTime) || 0;
      var endTime = parseFloat(section.dataset.endTime) || 0;
      var fadeMode = section.dataset.contentFadeMode || 'slide-up';
      var contentWrap = section.querySelector('.ne-hv__content-wrap');

      // Damped scrubbing (user QA 2026-06-13): scroll input — especially
      // mouse-wheel detents, but also touchpad steps — arrives in discrete
      // jumps. Mapping each jump straight onto video.currentTime makes the
      // playhead visibly step/stutter. Instead we ease a `displayProgress`
      // toward the scroll-derived `targetProgress` on a continuous rAF loop,
      // so wheel steps become smooth glides. The loop self-parks once it
      // settles (no scroll, eased to target) to save battery, and is
      // re-kicked by scroll / resize / re-entering the viewport.
      var rafId = null;
      var inView = true;
      var primed = false;
      var displayProgress = 0;
      var targetProgress = 0;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      // Per-frame easing factor (≈120 ms settle at 60 fps). 1 = no easing.
      var SMOOTH = prefersReduced ? 1 : 0.15;
      var SETTLE = 0.0006;

      function computeTarget() {
        var rect = section.getBoundingClientRect();
        var scrubRange = Math.max(1, section.offsetHeight - window.innerHeight);
        if (rect.top > 0) return 0;
        if (rect.bottom <= window.innerHeight) return 1;
        return Math.min(1, Math.max(0, -rect.top) / scrubRange);
      }

      function applyFrame(progress) {
        if (video.readyState >= 2) {
          if (endTime === 0 || endTime > video.duration) endTime = video.duration;
          var playableDuration = endTime - startTime;
          if (playableDuration > 0) {
            var newTime = startTime + (progress * playableDuration);
            // Never seek to the exact terminal frame — Firefox can blank a
            // scrubbed video to black on the ended frame (2026-06-17).
            var maxTime = endTime - 0.05;
            if (maxTime > startTime && newTime > maxTime) newTime = maxTime;
            if (Math.abs(video.currentTime - newTime) > 0.01) {
              video.currentTime = newTime;
            }
          }
        }

        // Content exit animation. Several modes — opacity-based fade
        // has the well-known glass-bloom-out artefact (browser
        // compositor de-renders backdrop-filter under parent opacity
        // changes). Slide and scale modes use transform-only updates
        // which keep the compositor layer stable for crisp glass.
        //
        // Skip animation entirely when the section is in mobile stack
        // mode (above/below): content lives OUTSIDE the sticky wrapper
        // there, so applying scrub-derived transforms to it would shift
        // the content visually while the user is scrolling through the
        // (very different) stacked layout — the user reported this as
        // "the textbox slides into the video section, sideways offset".
        var isMobileStack = window.matchMedia('(max-width: 749px)').matches
          && (section.classList.contains('ne-hv--mstack-above')
              || section.classList.contains('ne-hv--mstack-below'));
        if (contentWrap && !isMobileStack) {
          switch (fadeMode) {
            case 'none':
              break;
            case 'fade':
              contentWrap.style.opacity = String(Math.max(0, 1 - progress * 2.5));
              break;
            case 'slide-up':
              contentWrap.style.transform = 'translate3d(0, ' + (-progress * 60).toFixed(1) + 'vh, 0)';
              break;
            case 'slide-side':
              // Slide direction follows horizontal position: left-aligned
              // content slides left (out the side it's anchored to);
              // right or center slides right.
              var direction = section.dataset.contentPositionH === 'left' ? -1 : 1;
              contentWrap.style.transform = 'translate3d(' + (direction * progress * 80).toFixed(1) + 'vw, 0, 0)';
              break;
            case 'scale-down':
              var scale = Math.max(0.4, 1 - progress * 1.2);
              contentWrap.style.transform = 'scale3d(' + scale.toFixed(3) + ',' + scale.toFixed(3) + ',1)';
              contentWrap.style.opacity = String(Math.max(0, 1 - progress * 2.5));
              break;
          }
        } else if (contentWrap && isMobileStack) {
          // Reset any stale transform/opacity from a prior desktop frame
          // (e.g. user resized to mobile after scrubbing partway on desktop).
          contentWrap.style.transform = '';
          contentWrap.style.opacity = '';
        }
      }

      function loop() {
        rafId = null;
        targetProgress = computeTarget();
        if (!primed) {
          // Snap on the first frame (or after a (re)load) so the playhead
          // doesn't ease up from 0 when the hero is entered mid-page.
          displayProgress = targetProgress;
          primed = true;
        } else {
          displayProgress += (targetProgress - displayProgress) * SMOOTH;
        }
        if (Math.abs(targetProgress - displayProgress) < SETTLE) {
          displayProgress = targetProgress;
        }
        applyFrame(displayProgress);
        // Keep easing until settled; then park (next scroll re-kicks).
        if (inView && Math.abs(targetProgress - displayProgress) > SETTLE) {
          rafId = requestAnimationFrame(loop);
        }
      }

      function kick() {
        if (rafId === null && inView) rafId = requestAnimationFrame(loop);
      }

      video.addEventListener('loadedmetadata', function () {
        if (video.currentTime < startTime) video.currentTime = startTime;
        primed = false;
        kick();
      });

      // Lazy-load when section enters viewport (with margin so video is
      // ready by the time the user starts scrubbing)
      var loadObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            lazyLoadVideo(video);
            loadObs.disconnect();
          }
        });
      }, { threshold: 0, rootMargin: '50% 0px' });
      loadObs.observe(section);

      // Park the rAF loop while the hero is well off-screen; resume + re-kick
      // when it re-enters so we never burn frames easing a hidden video.
      var viewObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          inView = entry.isIntersecting;
          if (inView) kick();
        });
      }, { threshold: 0, rootMargin: '120% 0px' });
      viewObs.observe(section);

      window.addEventListener('scroll', kick, { passive: true });
      window.addEventListener('resize', kick, { passive: true });
      kick();
    }

    function setupMobileStack(section) {
      // For above/below stack modes, move the content-wrap out of the
      // sticky container on mobile so flex-column layout can position
      // it as a sibling (above-mode uses column-reverse to flip the
      // visual order). On desktop or in overlay mode, content stays
      // inside the sticky for full-bleed video overlay.
      var sticky = section.querySelector('.ne-hv__sticky');
      var contentWrap = section.querySelector('.ne-hv__content-wrap');
      if (!sticky || !contentWrap) return;

      var stackMode = '';
      if (section.classList.contains('ne-hv--mstack-above')) stackMode = 'above';
      else if (section.classList.contains('ne-hv--mstack-below')) stackMode = 'below';
      if (!stackMode) return;  // overlay (default) — leave DOM alone

      function adapt() {
        var atMobile = window.matchMedia('(max-width: 749px)').matches;
        if (atMobile) {
          if (stackMode === 'above') {
            // Content rendered BEFORE sticky in DOM — appears above the
            // video in normal block flow. Works for both regular stack
            // and scroll-scrub stack (content scrolled through first,
            // then sticky pins). Idempotent — only moves if needed.
            if (section.firstElementChild !== contentWrap) {
              section.insertBefore(contentWrap, section.firstElementChild);
            }
          } else {
            // Below mode: content as LAST element in section (after the
            // sticky-wrapper AND after the scrub-spacer). nextElementSibling
            // null means content is the final element child — idempotent.
            if (contentWrap.parentNode !== section || contentWrap.nextElementSibling !== null) {
              section.appendChild(contentWrap);
            }
          }
        } else {
          // Desktop: restore content inside sticky wrapper for overlay layout.
          if (contentWrap.parentNode !== sticky) {
            sticky.appendChild(contentWrap);
          }
        }
      }
      adapt();
      window.addEventListener('resize', adapt);
    }

    function initHero(section) {
      if (section.dataset.neHvInit === '1') return;
      section.dataset.neHvInit = '1';

      var video = section.querySelector('video.ne-hv__video');
      var mode = section.dataset.playbackMode;

      if (video) {
        switch (mode) {
          case 'click-to-play':
            setupClickToPlay(section, video);
            break;
          case 'scroll-scrub':
            setupScrollScrub(section, video);
            break;
          default:
            setupAutoplay(section, video);
        }
        setupSoundToggle(section, video);
      } else {
        // No <video> element — external YT/Vimeo path. Two cases:
        //   click-to-play: placeholder div, JS swaps to autoplay iframe
        //   autoplay-loop: iframe already mounted, cover hides brief play UI
        if (mode === 'click-to-play') {
          var placeholder = section.querySelector('.ne-hv__embed-placeholder');
          if (placeholder) setupEmbedClickToPlay(section, placeholder);
        } else {
          // autoplay (default) — also covers legacy 'autoplay-loop' value
          setupEmbedCover(section);
        }
      }

      setupMobileStack(section);
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-ne-hv]').forEach(initHero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-password-section]');
    if (!section) return;

    var toggle = section.querySelector('[data-password-toggle]');
    var form = section.querySelector('[data-password-form]');
    if (toggle && form) {
      toggle.addEventListener('click', function() {
        var isHidden = form.hasAttribute('hidden');
        if (isHidden) {
          form.removeAttribute('hidden');
          toggle.setAttribute('aria-expanded', 'true');
          var input = form.querySelector('input[type="password"]');
          if (input) input.focus();
        } else {
          form.setAttribute('hidden', '');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    /* X-Ray cursor effect — pattern mirrors theme-global X-Ray
       (assets/hyprism.js XRayEffect). Add `ne-password--xray-active`
       class only on first mousemove; remove on mouseleave document. */
    if (section.classList.contains('ne-password--xray')) {
      var overlay = section.querySelector('.ne-password__overlay');
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (overlay && !reduced) {
        var raf;
        function moveXray(e) {
          var rect = section.getBoundingClientRect();
          if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) {
            section.classList.remove('ne-password--xray-active');
            return;
          }
          if (!section.classList.contains('ne-password--xray-active')) {
            section.classList.add('ne-password--xray-active');
          }
          if (raf) cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function() {
            var x = ((e.clientX - rect.left) / rect.width) * 100;
            var y = ((e.clientY - rect.top) / rect.height) * 100;
            overlay.style.setProperty('--ne-xray-mouse-x', x + '%');
            overlay.style.setProperty('--ne-xray-mouse-y', y + '%');
          });
        }
        document.addEventListener('mousemove', moveXray, { passive: true });
        document.documentElement.addEventListener('mouseleave', function() {
          section.classList.remove('ne-password--xray-active');
        });
        document.addEventListener('touchstart', function() {
          section.classList.remove('ne-password--xray-active');
        }, { once: true, passive: true });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pretext-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var CHARSETS = {
      binary: '01',
      hex: '0123456789abcdef',
      ascii: '!"#$%&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~',
      random: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*<>?',
      'matrix': 'ｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜｦﾝ0123456789ABCDEF'
    };
    // Density-ranked chars for char-compose mode (sparse → dense).
    // Density ramp for char-compose fallback. Block char █ removed —
    // user feedback: full blocks look like a static silhouette rather
    // than a char composition. Range goes from sparse to dense punctuation.
    var DENSITY_CHARS = ' .,:;i!|+*x%#$@';

    // customText is merchant freetext read back (decoded) from a data-attribute;
    // escape it before it goes into any innerHTML builder below.
    function escapeHtml(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function pickPool(source, customText) {
      if (source === 'custom-text') {
        return customText && customText.length > 0 ? customText : 'AB';
      }
      return CHARSETS[source] || CHARSETS.random;
    }

    function poolForMatrix(source, customText) {
      // Matrix rain looks best with the katakana set; for explicit
      // sources we respect the user's pick but fall back to matrix.
      if (source === 'custom-text' && customText) return customText;
      return CHARSETS[source] || CHARSETS.matrix;
    }

    function randomChar(pool) {
      return pool.charAt(Math.floor(Math.random() * pool.length));
    }

    function readNum(section, prop, fallback) {
      // Read the COMPUTED value (cascaded through stylesheet rules,
      // including @media-query overrides), NOT just the inline style.
      // section.style.getPropertyValue only sees the inline declaration,
      // so an @media override of --ne-pb-font-size (mobile) would be
      // invisible — JS would always return the desktop value.
      var v = parseFloat(getComputedStyle(section).getPropertyValue(prop));
      return isNaN(v) ? fallback : v;
    }

    function readSchemeColor(section, prop, fallback) {
      var v = getComputedStyle(section).getPropertyValue(prop).trim();
      if (v) return v;
      // Fall back to the section's actual computed background-color
      // when the CSS var isn't resolving (covers schemes that don't
      // emit --ne-scheme-bg, or rendering-context quirks). Without
      // this fallback matrix-rain always painted black regardless of
      // the user's chosen scheme.
      if (prop === '--ne-scheme-bg') {
        var bg = getComputedStyle(section).backgroundColor;
        if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') return bg;
      }
      return fallback;
    }

    function gridFromSection(section, fontSize, cellWFactor, cellHFactor) {
      var rect = section.getBoundingClientRect();
      var w = Math.max(200, Math.floor(rect.width));
      var h = Math.max(40, Math.floor(rect.height));
      var cw = fontSize * (cellWFactor || 0.9);
      var ch = fontSize * (cellHFactor || 1.2);
      var cols = Math.max(4, Math.floor(w / cw));
      var rows = Math.max(1, Math.floor(h / ch));
      // Cap total cells to ~18k — enough for 1920×800 at fontSize 14
      // (cellW=11, cellH=17 → 175×47 = 8225 cells) AND fill mode at
      // smaller font (8×10 → 240×80 = 19200 → capped near 18k).
      // The previous 3500 cap left huge empty areas at the section
      // bottom because rows got truncated aggressively.
      var maxCells = 18000;
      if (cols * rows > maxCells) {
        rows = Math.max(1, Math.floor(maxCells / cols));
      }
      return { cols: cols, rows: rows, w: w, h: h };
    }

    // ─── Static marquee ─────────────────────────────────────────────
    // Multi-row layout fills the section. Each row scrolls at its own
    // (slightly varied) speed; alternate rows reverse direction for the
    // "dense text wall" feel (midjourney-style banner).
    function setupStaticMarquee(section, track, content, customText) {
      var pool = pickPool(content, customText);
      var fontSize = readNum(section, '--ne-pb-font-size', 14);
      var rect = section.getBoundingClientRect();
      var width = Math.max(200, Math.floor(rect.width));
      var height = Math.max(40, Math.floor(rect.height));
      var lineHeight = fontSize * 1.5;
      var rowCount = Math.max(1, Math.floor(height / lineHeight));
      var charsPerRow = Math.max(60, Math.ceil((width * 2) / (fontSize * 0.6)));

      function makeSeq() {
        if (content === 'custom-text' && customText) {
          var seq = '';
          var unit = customText + '   ·   ';
          while (seq.length < charsPerRow) seq += unit;
          return seq;
        }
        var s = '';
        for (var i = 0; i < charsPerRow; i++) s += randomChar(pool);
        return s;
      }

      var html = '';
      for (var r = 0; r < rowCount; r++) {
        var seq = escapeHtml(makeSeq());
        var reverse = r % 2 === 1;
        var rspeed = 0.7 + Math.random() * 0.6;  // 0.7x – 1.3x
        var cls = 'ne-pb__row' + (reverse ? ' ne-pb__row--reverse' : '');
        html += '<div class="' + cls + '" style="--row-speed:' + rspeed.toFixed(2) + '">' +
                '<span>' + seq + '</span><span>' + seq + '</span></div>';
      }
      track.innerHTML = html;
    }

    // ─── Jumping letters ────────────────────────────────────────────
    function setupJumpingLetters(section, track, content, customText) {
      var pool = pickPool(content, customText);
      var fontSize = readNum(section, '--ne-pb-font-size', 14);
      var grid = gridFromSection(section, fontSize, 0.9, 1.2);
      track.style.setProperty('--cols', grid.cols);
      track.style.setProperty('--rows', grid.rows);

      var total = grid.cols * grid.rows;
      var charSource = '';
      if (content === 'custom-text' && customText) {
        while (charSource.length < total) charSource += customText + ' ';
      }
      var html = '';
      for (var r = 0; r < grid.rows; r++) {
        for (var c = 0; c < grid.cols; c++) {
          var idx = r * grid.cols + c;
          var ch;
          if (charSource) {
            ch = charSource.charAt(idx % charSource.length);
          } else {
            ch = randomChar(pool);
          }
          if (ch === ' ') ch = ' ';
          html += '<span style="--i:' + c + ';--j:' + r + '">' + escapeHtml(ch) + '</span>';
        }
      }
      track.innerHTML = html;
    }

    // ─── Scramble reveal ────────────────────────────────────────────
    // Scramble reveal — text is revealed at a defined position (the
    // text_position setting), held briefly, then reverse-scrambled,
    // held, and re-revealed. Loop. Non-text cells continue cycling
    // random chars throughout. Same placement logic as scramble-pin
    // but with a continuous loop instead of one-shot.
    function setupScrambleReveal(section, track, content, customText, speed) {
      var pool = CHARSETS.random;
      var fontSize = readNum(section, '--ne-pb-font-size', 14);
      var grid = gridFromSection(section, fontSize, 0.8, 1.2);
      track.style.setProperty('--cols', grid.cols);
      track.style.setProperty('--rows', grid.rows);

      var total = grid.cols * grid.rows;
      var target = (customText && customText.length > 0) ? customText : 'INITIATING';

      // fillMode: target text repeats across the WHOLE grid (the original
      // loop behaviour the user asked to bring back). Lock-step batches
      // multiple cells per tick so the reveal completes in reasonable time.
      // Position mode: target placed once at text_position (also available
      // as one-shot via scramble_loop=false → replaces the dropped
      // scramble-pin mode).
      var fillMode = section.dataset.scrambleFill === '1';
      var loopMode = section.dataset.scrambleLoop !== '0';
      var pos = section.dataset.textPosition || 'center';

      var targets = new Array(total);
      var current = new Array(total);
      var locked = new Array(total);
      var isTextCell = new Array(total);
      var lockOrder = [];

      for (var i = 0; i < total; i++) {
        targets[i] = null;
        current[i] = randomChar(pool);
        locked[i] = false;
        isTextCell[i] = false;
      }

      if (fillMode) {
        var padded = target + '   ';
        for (var i2 = 0; i2 < total; i2++) {
          targets[i2] = padded.charAt(i2 % padded.length);
          isTextCell[i2] = true;
          lockOrder.push(i2);
        }
      } else {
        var maxLen = Math.min(target.length, grid.cols);
        target = target.slice(0, maxLen);
        var textRow, textColStart;
        if (pos.indexOf('top') === 0)         textRow = Math.max(0, Math.floor(grid.rows * 0.18));
        else if (pos.indexOf('bottom') === 0) textRow = Math.max(0, grid.rows - 1 - Math.floor(grid.rows * 0.18));
        else                                   textRow = Math.floor((grid.rows - 1) / 2);
        if (pos.indexOf('-left') > -1)        textColStart = 1;
        else if (pos.indexOf('-right') > -1)  textColStart = Math.max(0, grid.cols - maxLen - 1);
        else                                   textColStart = Math.floor((grid.cols - maxLen) / 2);
        for (var k = 0; k < maxLen; k++) {
          var ci = textRow * grid.cols + textColStart + k;
          if (ci >= 0 && ci < total) {
            targets[ci] = target.charAt(k);
            isTextCell[ci] = true;
            lockOrder.push(ci);
          }
        }
      }

      var html = '';
      for (var j = 0; j < total; j++) {
        var disp = current[j] === ' ' ? ' ' : current[j];
        html += '<span>' + escapeHtml(disp) + '</span>';
      }
      track.innerHTML = html;
      var spans = track.querySelectorAll('span');

      function setCell(idx, ch, lock) {
        if (!spans[idx]) return;
        spans[idx].textContent = ch === ' ' ? ' ' : ch;
        if (lock !== undefined) spans[idx].classList.toggle('is-locked', !!lock);
      }

      var lockedCount = 0;
      var direction = 1;
      var lockInterval = Math.max(30, Math.floor(180 - speed * 1.4));
      var cycleInterval = Math.max(40, Math.floor(160 - speed * 1.0));
      // Batch lock-step in fillMode to keep reveal time reasonable on
      // huge grids (~80 ticks total). Position mode locks one per tick.
      var batchSize = fillMode ? Math.max(1, Math.floor(lockOrder.length / 80)) : 1;

      function lockStep() {
        if (direction === 1) {
          if (lockedCount < lockOrder.length) {
            for (var b = 0; b < batchSize && lockedCount < lockOrder.length; b++) {
              var idx = lockOrder[lockedCount];
              current[idx] = targets[idx];
              setCell(idx, current[idx], true);
              locked[idx] = true;
              lockedCount++;
            }
          } else if (!section._pbHoldTimer) {
            if (!loopMode) return;
            section._pbHoldTimer = setTimeout(function () {
              direction = -1;
              section._pbHoldTimer = null;
            }, 2200);
          }
        } else {
          if (lockedCount > 0) {
            for (var b2 = 0; b2 < batchSize && lockedCount > 0; b2++) {
              lockedCount--;
              var idx2 = lockOrder[lockedCount];
              locked[idx2] = false;
              current[idx2] = randomChar(pool);
              setCell(idx2, current[idx2], false);
            }
          } else if (!section._pbHoldTimer) {
            section._pbHoldTimer = setTimeout(function () {
              direction = 1;
              section._pbHoldTimer = null;
            }, 700);
          }
        }
      }

      function cycleUnlocked() {
        for (var i = 0; i < total; i++) {
          if (isTextCell[i] && locked[i]) continue;
          if (Math.random() < 0.3) {
            current[i] = randomChar(pool);
            setCell(i, current[i]);
          }
        }
      }

      var lockT = setInterval(lockStep, lockInterval);
      var cycleT = setInterval(cycleUnlocked, cycleInterval);
      section._pbTimers = [lockT, cycleT];
    }


    // Scramble pin — like scramble-reveal but the target text appears at
    // a defined position (top/middle/bottom × left/center/right) and is
    // revealed ONCE. After full reveal, target cells stay locked; the
    // rest of the grid keeps cycling random chars forever (continuous
    // background scramble with a "pinned" headline).
    function setupScramblePin(section, track, content, customText, speed) {
      var pool = CHARSETS.random;
      var fontSize = readNum(section, '--ne-pb-font-size', 14);
      var grid = gridFromSection(section, fontSize, 0.8, 1.2);
      track.style.setProperty('--cols', grid.cols);
      track.style.setProperty('--rows', grid.rows);

      var total = grid.cols * grid.rows;
      var target = (customText && customText.length > 0) ? customText : 'INITIATING';
      var pos = section.dataset.textPosition || 'center';

      // Compute the row and starting col for the pinned text. If the
      // target is longer than cols, truncate (single-row placement).
      var maxLen = Math.min(target.length, grid.cols);
      target = target.slice(0, maxLen);
      var textRow, textColStart;
      if (pos.indexOf('top') === 0)         textRow = Math.max(0, Math.floor(grid.rows * 0.18));
      else if (pos.indexOf('bottom') === 0) textRow = Math.max(0, grid.rows - 1 - Math.floor(grid.rows * 0.18));
      else                                   textRow = Math.floor((grid.rows - 1) / 2);
      if (pos.indexOf('-left') > -1)        textColStart = 1;
      else if (pos.indexOf('-right') > -1)  textColStart = Math.max(0, grid.cols - maxLen - 1);
      else                                   textColStart = Math.floor((grid.cols - maxLen) / 2);

      var targets = new Array(total);
      var current = new Array(total);
      var locked = new Array(total);
      var isTextCell = new Array(total);

      for (var i = 0; i < total; i++) {
        targets[i] = null;
        current[i] = randomChar(pool);
        locked[i] = false;
        isTextCell[i] = false;
      }
      // Place target chars in the pinned region.
      for (var k = 0; k < maxLen; k++) {
        var ci = textRow * grid.cols + textColStart + k;
        if (ci >= 0 && ci < total) {
          targets[ci] = target.charAt(k);
          isTextCell[ci] = true;
        }
      }

      var html = '';
      for (var j = 0; j < total; j++) {
        var disp = current[j] === ' ' ? '\u00A0' : current[j];
        html += '<span>' + escapeHtml(disp) + '</span>';
      }
      track.innerHTML = html;
      var spans = track.querySelectorAll('span');

      function setCell(idx, ch, lock) {
        if (!spans[idx]) return;
        spans[idx].textContent = ch === ' ' ? '\u00A0' : ch;
        if (lock !== undefined) spans[idx].classList.toggle('is-locked', !!lock);
      }

      // Build the lock order (only over text cells, left-to-right).
      var lockOrder = [];
      for (var k2 = 0; k2 < maxLen; k2++) {
        lockOrder.push(textRow * grid.cols + textColStart + k2);
      }

      var lockedCount = 0;
      var revealComplete = false;
      var lockInterval = Math.max(40, Math.floor(220 - speed * 1.6));
      var cycleInterval = Math.max(40, Math.floor(160 - speed * 1.0));

      function lockStep() {
        if (revealComplete) return;
        if (lockedCount < lockOrder.length) {
          var idx = lockOrder[lockedCount];
          current[idx] = targets[idx];
          setCell(idx, current[idx], true);
          locked[idx] = true;
          lockedCount++;
        } else {
          revealComplete = true;
          // Stop locking — pinned text stays put; cycle keeps running.
          clearInterval(lockT);
        }
      }

      function cycleUnlocked() {
        // Cycle ~30% of non-text cells per tick. Text cells, once locked,
        // are skipped permanently.
        for (var i = 0; i < total; i++) {
          if (isTextCell[i]) continue;
          if (Math.random() < 0.3) {
            current[i] = randomChar(pool);
            setCell(i, current[i]);
          }
        }
      }

      var lockT = setInterval(lockStep, lockInterval);
      var cycleT = setInterval(cycleUnlocked, cycleInterval);
      section._pbTimers = [lockT, cycleT];
    }

    // ─── Matrix rain (Canvas) ───────────────────────────────────────
    function setupMatrixRain(section, canvas, content, customText, speed) {
      var ctx = canvas.getContext('2d');
      var pool = poolForMatrix(content, customText);
      var dpr = window.devicePixelRatio || 1;
      var fontSize = readNum(section, '--ne-pb-font-size', 14);
      var accent = readSchemeColor(section, '--ne-scheme-accent', '#22ff77');
      var bg = readSchemeColor(section, '--ne-scheme-bg', '#000000');
      var w = 0, h = 0, cols = 0;
      var drops = [];
      var rafId = 0;
      var lastTick = 0;
      // Drop step rate — speed 50 = ~22 fps for a calm classic look.
      var stepMs = Math.max(20, Math.round(1500 / Math.max(speed, 5)));

      function resize() {
        // Re-read fontSize live (not the cached setup-time value) so
        // viewport changes Desktop ↔ Mobile in the Customizer pick up
        // the @media-overridden --ne-pb-font-size value.
        fontSize = readNum(section, '--ne-pb-font-size', 14);
        var rect = section.getBoundingClientRect();
        w = Math.max(1, Math.floor(rect.width));
        h = Math.max(1, Math.floor(rect.height));
        canvas.width = w * dpr;
        canvas.height = h * dpr;
        canvas.style.width = w + 'px';
        canvas.style.height = h + 'px';
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.scale(dpr, dpr);
        var colW = fontSize * 0.8;
        cols = Math.max(1, Math.floor(w / colW));
        var prev = drops.slice();
        drops = new Array(cols);
        for (var i = 0; i < cols; i++) {
          drops[i] = (prev[i] !== undefined) ? prev[i] : Math.random() * (h / fontSize);
        }
        // Reset to transparent (no bg fill) — the section's CSS background
        // shows through. This lets glass / transparent / scheme backgrounds
        // all work correctly. Previously a bg-fill painted opaque over
        // the section, hiding glass blur and scheme transparency.
        ctx.clearRect(0, 0, w, h);
      }
      resize();

      function frame(t) {
        if (t - lastTick < stepMs) {
          rafId = requestAnimationFrame(frame);
          return;
        }
        lastTick = t;

        // Trail fade — reduce existing pixels' alpha via destination-out
        // instead of painting bg color. Keeps canvas transparent so the
        // section's CSS background (scheme bg, glass, or transparent)
        // remains visible behind the chars. The 0.18 alpha controls how
        // fast trails fade — higher = shorter trails.
        ctx.globalCompositeOperation = 'destination-out';
        ctx.fillStyle = 'rgba(0, 0, 0, 0.18)';
        ctx.fillRect(0, 0, w, h);
        ctx.globalCompositeOperation = 'source-over';

        ctx.fillStyle = accent;
        ctx.font = fontSize + 'px ui-monospace, monospace';
        ctx.textBaseline = 'top';
        var colW = w / cols;
        for (var i = 0; i < cols; i++) {
          var c = pool.charAt(Math.floor(Math.random() * pool.length));
          var x = i * colW;
          var y = drops[i] * fontSize;
          ctx.fillText(c, x, y);
          if (y > h && Math.random() > 0.975) drops[i] = 0;
          drops[i]++;
        }
        // Carved-out is handled via CSS mask on the canvas element
        // (SVG mask with shape-accurate image alpha) — no per-frame
        // carve code needed in the draw loop.
        rafId = requestAnimationFrame(frame);
      }
      rafId = requestAnimationFrame(frame);

      var resizeHandler = function () { resize(); };
      window.addEventListener('resize', resizeHandler, { passive: true });
      // Section dimensions may change without a window-resize event
      // (customizer settings changes, layout reflows after font load).
      // ResizeObserver picks up the actual section box-size changes
      // so the canvas keeps matching the section.
      var ro = null;
      if (typeof ResizeObserver !== 'undefined') {
        ro = new ResizeObserver(function () { resize(); });
        ro.observe(section);
      }
      section._pbRaf = function () { return rafId; };
      section._pbResize = resizeHandler;
      section._pbResizeObs = ro;
    }

    // ─── Char compose (Canvas) ──────────────────────────────────────
    function setupCharCompose(section, canvas, content, customText, speed, animMode) {
      var ctx = canvas.getContext('2d');
      var pool = pickPool(content, customText);
      var src = section.dataset.imageSrc;
      if (!src) return;
      var img = new Image();
      img.crossOrigin = 'anonymous';
      var dpr = window.devicePixelRatio || 1;
      var fontSize = readNum(section, '--ne-pb-font-size', 14);
      var accent = readSchemeColor(section, '--ne-scheme-accent', '#ffffff');
      var bg = readSchemeColor(section, '--ne-scheme-bg', '#000000');
      var w = 0, h = 0, cols = 0, rows = 0;
      var imgData = null;
      // Auto-detect: if image has transparency (any pixel with alpha < 250),
      // use ALPHA for density (handles logos with transparent bg + light
      // strokes — luminance alone would skip light pixels). Else use
      // luminance (handles full-color opaque images).
      var useAlphaDensity = false;
      var rafId = 0;
      var tick = 0;

      function sampleImage() {
        if (!img.complete || img.naturalWidth === 0) return;
        var off = document.createElement('canvas');
        off.width = cols;
        off.height = rows;
        var oc = off.getContext('2d');

        // Sample from the <img> element's rendered rect (width:image_size%,
        // height:auto = natural aspect). This matches what overlay-on-top
        // and carved-out modes show visually — all three modes hit the
        // same iRect coordinates. If the natural aspect causes the image
        // to overflow the section vertically (e.g. SVGs whose viewBox
        // declares portrait aspect even when the visible content is
        // square/landscape, as with Solomining_S.svg), drawImage will
        // sample the overflowing region into the off-canvas anyway —
        // visible chars will be the middle slice that overlaps the
        // section, which is exactly where the artwork sits.
        //
        // Earlier attempt: fit the sample inside a image_size%×image_size%
        // box with aspect-preserved scaling. That shrunk the width when
        // natural aspect was portrait, producing a much narrower char
        // silhouette than overlay-on-top showed for the same image —
        // contradiction between the two modes.
        var imgEl = section.querySelector('.ne-pb__image');
        var sRect = section.getBoundingClientRect();
        var iRect = imgEl ? imgEl.getBoundingClientRect() : null;
        var dw, dh, dx, dy;
        if (iRect && iRect.width > 1 && iRect.height > 1 && sRect.width > 0) {
          var sx = cols / sRect.width;
          var sy = rows / sRect.height;
          dx = (iRect.left - sRect.left) * sx;
          dy = (iRect.top - sRect.top) * sy;
          dw = iRect.width * sx;
          dh = iRect.height * sy;
        } else {
          // Fallback: centered contain in the full grid.
          var ir = img.naturalWidth / img.naturalHeight;
          var gr = cols / rows;
          if (ir > gr) { dw = cols; dh = cols / ir; dx = 0; dy = (rows - dh) / 2; }
          else        { dh = rows; dw = rows * ir; dx = (cols - dw) / 2; dy = 0; }
        }
        oc.fillStyle = 'rgba(0,0,0,0)';
        oc.fillRect(0, 0, cols, rows);
        oc.drawImage(img, dx, dy, dw, dh);
        try {
          imgData = oc.getImageData(0, 0, cols, rows).data;
        } catch (err) {
          // CORS taint — image was loaded but pixel access blocked.
          // Fall back to rendering the image directly to the visible
          // canvas (loses char-compose effect but at least shows the
          // image so the section isn't blank).
          imgData = null;
          ctx.fillStyle = bg;
          ctx.fillRect(0, 0, w, h);
          ctx.drawImage(img, 0, 0, w, h);
          if (typeof console !== 'undefined' && console.warn) {
            console.warn('[pretext-banner] char-compose: cross-origin pixel access blocked, falling back to image render');
          }
          return;
        }
        // Detect if image has meaningful transparency.
        useAlphaDensity = false;
        for (var i = 3; i < imgData.length; i += 4) {
          if (imgData[i] > 10 && imgData[i] < 240) { useAlphaDensity = true; break; }
        }
        // Edge case: fully opaque OR fully transparent → luminance.
        // Mixed alpha (logo on transparent bg) → alpha density.
      }

      function resize() {
        // Re-read fontSize live so viewport changes (Customizer mobile/
        // desktop preview toggle) re-apply the @media-overridden value.
        fontSize = readNum(section, '--ne-pb-font-size', 14);
        var rect = section.getBoundingClientRect();
        w = Math.max(1, Math.floor(rect.width));
        h = Math.max(1, Math.floor(rect.height));
        canvas.width = w * dpr;
        canvas.height = h * dpr;
        canvas.style.width = w + 'px';
        canvas.style.height = h + 'px';
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.scale(dpr, dpr);
        var cw = fontSize * 0.6;
        var rh = fontSize;
        cols = Math.max(1, Math.floor(w / cw));
        rows = Math.max(1, Math.floor(h / rh));
        sampleImage();
      }

      // Persistent char grid — evolved each tick per the animation_mode
      // pattern so char-compose has visible variety across modes:
      //   • static-marquee → grid shifts horizontally each tick
      //   • matrix-rain    → grid shifts vertically each tick
      //   • scramble-reveal → progressive lock-reveal of the image
      //                       silhouette from random noise (see below)
      //   • scramble-pin   → static after first regen
      //   • jumping-letters → random subset cells regenerate each tick
      var charGrid = [];

      // ─── Scramble-reveal char-compose state ────────────────────────
      // Combined effect: cells start as random noise at uniform low
      // opacity (no silhouette visible). lockOrder is a shuffled cell-
      // index list; each tick a batch of cells "locks" to its density-
      // mapped target character + full density alpha, progressively
      // materialising the image silhouette out of chaos. If scramble_loop
      // is on, the lock-state reverses after a hold and the silhouette
      // dissolves back to noise → loops forever.
      var srLockOrder = null;       // shuffled cell indices (length === total)
      var srLockedFlags = null;     // bool[total], true if cell is locked
      var srLockedIdx = 0;          // count of locks consumed from lockOrder
      var srDirection = 1;          // 1 = revealing, -1 = unrevealing
      var srTargetGrid = null;      // char[total] — density-mapped target chars
      var srLoopMode = section.dataset.scrambleLoop !== '0';

      function buildScrambleRevealData(total) {
        // Requires imgData (sampled). Build target chars from per-cell
        // density mapped onto the active pool (binary/hex/ASCII/custom).
        // Density 0..1 maps linearly to pool index 0..len-1, so sparser
        // cells get earlier chars (e.g. '0' for binary) and denser cells
        // get later chars ('1'). For DENSITY_CHARS fallback this gives a
        // proper sparse→dense ASCII-art ramp at the locked state.
        if (!imgData) return false;
        var p = (pool && pool.length > 0) ? pool : DENSITY_CHARS;
        var plen = p.length;
        srTargetGrid = new Array(total);
        for (var i = 0; i < total; i++) {
          var pidx = i * 4;
          var ir = imgData[pidx], ig = imgData[pidx + 1], ib = imgData[pidx + 2], ia = imgData[pidx + 3];
          var density;
          if (useAlphaDensity) {
            density = ia / 255;
          } else {
            if (ia < 30) density = 0;
            else density = 1 - (ir * 0.299 + ig * 0.587 + ib * 0.114) / 255;
          }
          density = Math.max(0, Math.min(1, density));
          var ti = Math.floor(density * (plen - 1));
          if (ti < 0) ti = 0;
          if (ti > plen - 1) ti = plen - 1;
          srTargetGrid[i] = p.charAt(ti);
        }
        // Fisher-Yates shuffle for lock order
        srLockOrder = new Array(total);
        for (var i = 0; i < total; i++) srLockOrder[i] = i;
        for (var i = total - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var tmp = srLockOrder[i]; srLockOrder[i] = srLockOrder[j]; srLockOrder[j] = tmp;
        }
        srLockedFlags = new Array(total);
        for (var i = 0; i < total; i++) srLockedFlags[i] = false;
        srLockedIdx = 0;
        srDirection = 1;
        return true;
      }

      function evolveScrambleReveal(total) {
        // Lazy build / rebuild when grid count changed (resize).
        if (!srLockOrder || srLockOrder.length !== total || !srTargetGrid || srTargetGrid.length !== total) {
          var ok = buildScrambleRevealData(total);
          if (!ok) {
            // imgData not ready yet — just keep noise
            regenGrid(total);
            return;
          }
        }
        // Refresh unlocked cells with random chars each tick (creates
        // the "scrambling" texture on unlocked area).
        var src = (pool && pool.length > 0) ? pool : DENSITY_CHARS;
        for (var i = 0; i < total; i++) {
          if (!srLockedFlags[i]) {
            charGrid[i] = src.charAt(Math.floor(Math.random() * src.length));
          }
        }
        // Advance lock-state. Batch size aims for ~80 evolve ticks to
        // fully cover the section (lockedIdx 0 → total), regardless of
        // grid resolution.
        var batchSize = Math.max(1, Math.floor(total / 80));
        if (srDirection === 1) {
          var nextLocked = Math.min(total, srLockedIdx + batchSize);
          for (var i = srLockedIdx; i < nextLocked; i++) {
            srLockedFlags[srLockOrder[i]] = true;
          }
          srLockedIdx = nextLocked;
          if (srLockedIdx >= total && !section._pbSrHoldTimer) {
            if (srLoopMode) {
              section._pbSrHoldTimer = setTimeout(function () {
                srDirection = -1;
                section._pbSrHoldTimer = null;
              }, 2200);
            }
            // Non-loop: stay fully revealed
          }
        } else {
          var nextLocked = Math.max(0, srLockedIdx - batchSize);
          for (var i = nextLocked; i < srLockedIdx; i++) {
            srLockedFlags[srLockOrder[i]] = false;
          }
          srLockedIdx = nextLocked;
          if (srLockedIdx <= 0 && !section._pbSrHoldTimer) {
            section._pbSrHoldTimer = setTimeout(function () {
              srDirection = 1;
              section._pbSrHoldTimer = null;
            }, 800);
          }
        }
      }

      function regenGrid(total) {
        charGrid = new Array(total);
        var src = (pool && pool.length > 0) ? pool : DENSITY_CHARS;
        for (var i = 0; i < total; i++) {
          charGrid[i] = src.charAt(Math.floor(Math.random() * src.length));
        }
      }
      function shiftHoriz(total) {
        // Shift each row by 1 to the right; wrap end to start.
        var src = (pool && pool.length > 0) ? pool : DENSITY_CHARS;
        for (var r = 0; r < rows; r++) {
          // Inject a new random char at col 0; shift the rest.
          var rowStart = r * cols;
          for (var c = cols - 1; c > 0; c--) {
            charGrid[rowStart + c] = charGrid[rowStart + c - 1];
          }
          charGrid[rowStart] = src.charAt(Math.floor(Math.random() * src.length));
        }
      }
      function shiftVert(total) {
        // Shift each col by 1 down; wrap bottom to top.
        var src = (pool && pool.length > 0) ? pool : DENSITY_CHARS;
        for (var c = 0; c < cols; c++) {
          for (var r = rows - 1; r > 0; r--) {
            charGrid[r * cols + c] = charGrid[(r - 1) * cols + c];
          }
          charGrid[c] = src.charAt(Math.floor(Math.random() * src.length));
        }
      }
      function jitterGrid(total) {
        // Replace ~55% of cells with new random chars per tick (jumping
        // feel — scattered changes that read as rapid update). Was 25%
        // but the change was too subtle to be distinguishable from
        // scramble at higher tick rates.
        var src = (pool && pool.length > 0) ? pool : DENSITY_CHARS;
        var n = Math.max(1, Math.floor(total * 0.55));
        for (var k = 0; k < n; k++) {
          var i = Math.floor(Math.random() * total);
          charGrid[i] = src.charAt(Math.floor(Math.random() * src.length));
        }
      }
      function evolveGrid(total) {
        if (animMode === 'static-marquee')      shiftHoriz(total);
        else if (animMode === 'matrix-rain')    shiftVert(total);
        else if (animMode === 'jumping-letters') jitterGrid(total);
        else if (animMode === 'scramble-pin')   { /* static — chars stay after first regen */ }
        else if (animMode === 'scramble-reveal') evolveScrambleReveal(total);
        else                                     regenGrid(total);
      }

      // Speed → regen frequency. The shift-based patterns
      // (static-marquee, matrix-rain) need much faster cadence than the
      // full-regen patterns to look like actual movement — a shift of
      // one column every 30 frames is barely perceptible. Per-mode
      // rates make the chosen animation_mode visually distinct.
      var s = speed || 50;
      var regenFrames;
      if (animMode === 'static-marquee' || animMode === 'matrix-rain') {
        regenFrames = Math.max(1, Math.floor(12 - s * 0.1));   // 1–11 frames
      } else if (animMode === 'jumping-letters') {
        regenFrames = Math.max(2, Math.floor(20 - s * 0.15));  // 2–18 frames
      } else {
        regenFrames = Math.max(2, Math.floor(40 - s * 0.35));  // 2–36 frames
      }

      function frame() {
        if (!imgData) {
          rafId = requestAnimationFrame(frame);
          return;
        }
        var total = rows * cols;
        if (charGrid.length !== total) regenGrid(total);
        if (tick % regenFrames === 0) evolveGrid(total);

        // Transparent canvas — section's CSS bg shows through (glass-friendly).
        ctx.clearRect(0, 0, w, h);
        ctx.font = fontSize + 'px ui-monospace, monospace';
        ctx.textBaseline = 'top';

        // Per-cell color from the image's RGB is opt-in via the
        // data-image-color="1" attribute. Default: monochrome accent.
        // Background chars (outside the image silhouette) use the
        // less-saturated scheme-text color so they read as "background
        // hum" rather than accent-coloured noise. Read inside the
        // frame loop so Customizer toggles apply on next frame.
        var useImgColor = section.dataset.imageColor === '1';
        var bgColor = readSchemeColor(section, '--ne-scheme-text', accent);
        var bgOpacity = parseFloat(section.dataset.bgCharOpacity);
        if (isNaN(bgOpacity)) bgOpacity = 0.15;

        var cw = w / cols;
        var rh = h / rows;
        // Per-mode visible-pattern offset. Jumping mode gets a vertical
        // sin-wave so chars actually BOUNCE (otherwise random regen
        // looks the same as scramble). Scramble modes stay random-only.
        var jumpAmp = (animMode === 'jumping-letters') ? rh * 0.25 : 0;
        var jumpPhaseBase = tick * 0.08;
        // Scramble-reveal char-compose mode: unlocked cells render as
        // muted noise (no silhouette), locked cells reveal their density-
        // mapped target char with full density alpha. Detect once outside
        // the inner loop so the per-cell branch is cheap.
        var isSrMode = (animMode === 'scramble-reveal') && srLockedFlags && srTargetGrid;
        for (var r = 0; r < rows; r++) {
          for (var c = 0; c < cols; c++) {
            var cellIdx = r * cols + c;
            var idx = cellIdx * 4;
            var ir = imgData[idx], ig = imgData[idx + 1], ib = imgData[idx + 2], ia = imgData[idx + 3];
            var density, inImage;
            if (useAlphaDensity) {
              density = ia / 255;
              inImage = ia > 30;
            } else {
              if (ia < 30) {
                density = bgOpacity;
                inImage = false;
              } else {
                var lum = (ir * 0.299 + ig * 0.587 + ib * 0.114) / 255;
                density = 1 - lum;
                inImage = true;
              }
            }
            var alpha, fillColor, charOut;
            if (isSrMode && !srLockedFlags[cellIdx]) {
              // Unlocked: uniform low-opacity noise, no silhouette,
              // always bg-color so the silhouette isn't pre-visible.
              alpha = bgOpacity * 0.5;
              fillColor = bgColor;
              charOut = charGrid[cellIdx];
            } else {
              // Locked OR non-scramble-reveal mode: density-mapped alpha
              // + accent (or per-pixel RGB if image-color opt-in).
              if (inImage) {
                alpha = Math.max(0.2, Math.min(1, density));
                if (useImgColor && (ir || ig || ib)) {
                  fillColor = 'rgb(' + ir + ',' + ig + ',' + ib + ')';
                } else {
                  fillColor = accent;
                }
              } else {
                alpha = bgOpacity;
                fillColor = bgColor;
              }
              // In SR mode, locked cells lock onto their density-mapped
              // target char for crisp "ASCII-art reveal"; other modes
              // keep the random/shifted grid char.
              charOut = (isSrMode) ? srTargetGrid[cellIdx] : charGrid[cellIdx];
            }
            ctx.globalAlpha = alpha;
            ctx.fillStyle = fillColor;
            var yOff = 0;
            if (jumpAmp > 0) {
              // Phase offset by (r + c) so the wave travels diagonally
              // — visible motion that's clearly distinct from scramble.
              yOff = Math.sin(jumpPhaseBase + r * 0.5 + c * 0.3) * jumpAmp;
            }
            ctx.fillText(charOut, c * cw, r * rh + yOff);
          }
        }
        ctx.globalAlpha = 1;
        tick++;
        rafId = requestAnimationFrame(frame);
      }

      img.addEventListener('load', function () {
        resize();
        // Only start the rAF loop if pixel sampling succeeded (sampleImage
        // sets imgData on success or leaves it null on CORS failure, in
        // which case the image is already rendered via fallback).
        if (imgData) rafId = requestAnimationFrame(frame);
      });
      img.addEventListener('error', function () {
        if (typeof console !== 'undefined' && console.warn) {
          console.warn('[pretext-banner] char-compose: image failed to load', src);
        }
      });
      img.src = src;

      var resizeHandler = function () { resize(); };
      window.addEventListener('resize', resizeHandler, { passive: true });
      // ResizeObserver picks up section box-size changes that don't
      // fire a window-resize (customizer setting tweaks etc.). Without
      // this the canvas can stay sized to the initial getBoundingClientRect
      // which may be incomplete before layout settles.
      var ro = null;
      if (typeof ResizeObserver !== 'undefined') {
        ro = new ResizeObserver(function () { resize(); });
        ro.observe(section);
      }
      section._pbResize = resizeHandler;
      section._pbResizeObs = ro;
      section._pbRaf = function () { return rafId; };
    }

    // ─── Init / teardown ────────────────────────────────────────────
    function init(section) {
      if (section.dataset.nePbInit === '1') return;
      section.dataset.nePbInit = '1';

      var anim = section.dataset.animationMode || 'static-marquee';
      // Backward-compat: scramble-pin was merged into scramble-reveal
      // with loop=off. Old saved data with 'scramble-pin' routes here.
      if (anim === 'scramble-pin') {
        anim = 'scramble-reveal';
        section.dataset.scrambleLoop = '0';
      }
      var content = section.dataset.contentSource || 'binary';
      var customText = section.dataset.customText || '';
      var speed = parseInt(section.dataset.animationSpeed, 10) || 50;
      var imageMode = section.dataset.imageMode || 'overlay-on-top';
      var hasImage = !!section.dataset.imageSrc;

      var canvas = section.querySelector('[data-pb-canvas]');
      var dom = section.querySelector('[data-pb-dom]');
      var track = section.querySelector('[data-pb-track]');
      if (!canvas || !dom || !track) return;

      // Char-compose overrides the animation mode — canvas owns it.
      if (hasImage && imageMode === 'char-compose') {
        dom.hidden = true;
        canvas.hidden = false;
        setupCharCompose(section, canvas, content, customText, speed, anim);
        return;
      }

      if (anim === 'matrix-rain') {
        dom.hidden = true;
        canvas.hidden = false;
        setupMatrixRain(section, canvas, content, customText, speed);
      } else {
        canvas.hidden = true;
        dom.hidden = false;
        if (anim === 'jumping-letters') {
          setupJumpingLetters(section, track, content, customText);
        } else if (anim === 'scramble-reveal') {
          setupScrambleReveal(section, track, content, customText, speed);
        } else if (anim === 'scramble-pin') {
          setupScramblePin(section, track, content, customText, speed);
        } else {
          setupStaticMarquee(section, track, content, customText);
        }
      }

      // Carved-out — JS-based image-area exclusion. The CSS mask-composite
      // approach was unreliable in the Customizer iframe (silent fallback
      // to no-mask, indistinguishable from overlay-on-top). This runs
      // after the animation is set up: it locates the image element's
      // rendered rectangle inside the section and either hides DOM cells
      // whose centers fall inside that rect, or schedules a per-frame
      // canvas clear over that rect for matrix-rain.
      if (hasImage && imageMode === 'carved-out') {
        setupCarvedOut(section, anim);
      }

      // Re-init on mobile/desktop breakpoint cross — Shopify Customizer
      // does NOT fire shopify:section:load on viewport toggle, so DOM-
      // based animations (scramble-reveal, jumping-letters, static-
      // marquee) keep their stale setup-time grid count (cols × rows
      // baked into innerHTML + lockOrder). After crossing the 749px
      // breakpoint, the section dimensions changed but the DOM didn't
      // — bottom rows can't lock because their indices aren't in
      // lockOrder. Force teardown + re-init when the breakpoint flips
      // so the DOM rebuilds with current dimensions. Canvas modes
      // already handle this via their own ResizeObserver, but the
      // listener here is universal so no regressions either way.
      if (window.matchMedia && !section._pbMql) {
        var mql = window.matchMedia('(max-width: 749px)');
        var mqlHandler = function () {
          teardown(section);
          // rAF defer so the new layout settles (computed styles, new
          // section width via @media min-height + page width vars)
          // before the re-init reads getBoundingClientRect.
          requestAnimationFrame(function () { init(section); });
        };
        if (mql.addEventListener) mql.addEventListener('change', mqlHandler);
        else if (mql.addListener) mql.addListener(mqlHandler);
        section._pbMql = mql;
        section._pbMqlHandler = mqlHandler;
      }

      // DOM-mode grids (scramble-reveal/pin, jumping-letters, static-marquee)
      // bake cols x rows from the section size at build time and — unlike the
      // canvas modes — have no resize handling. A grid built before the
      // section reached its final height (or after a height / font-size
      // change) keeps a stale, too-small row count. Rebuild on real size
      // changes — debounced + guarded so the animation does not restart on
      // sub-pixel reflow. Canvas modes own their own ResizeObserver → skip.
      var _pbDomModes = { 'scramble-reveal': 1, 'jumping-letters': 1, 'static-marquee': 1 };
      if (typeof ResizeObserver !== 'undefined' && _pbDomModes[anim] && !section._pbDomRO) {
        var _pbLastW = Math.round(section.getBoundingClientRect().width);
        var _pbLastH = Math.round(section.getBoundingClientRect().height);
        var _pbDomRO = new ResizeObserver(function () {
          if (section._pbDomROTimer) clearTimeout(section._pbDomROTimer);
          section._pbDomROTimer = setTimeout(function () {
            var r = section.getBoundingClientRect();
            var w = Math.round(r.width), h = Math.round(r.height);
            if (Math.abs(w - _pbLastW) < 4 && Math.abs(h - _pbLastH) < 4) return;
            _pbLastW = w; _pbLastH = h;
            try { _pbDomRO.disconnect(); } catch (e) {}
            section._pbDomRO = null;
            teardown(section);
            requestAnimationFrame(function () { init(section); });
          }, 200);
        });
        _pbDomRO.observe(section);
        section._pbDomRO = _pbDomRO;
      }
    }

    function setupCarvedOut(section, anim) {
      // SVG-mask-based carve. The mask + filter are emitted in Liquid;
      // CSS applies it to canvas + DOM layers automatically via the
      // --ne-pb-mask-url custom property. Position the SVG <image>
      // inside the mask to match the rendered <img> element's rect —
      // natural-aspect rendering (width:image_size%, height:auto).
      // preserveAspectRatio="meet" on the SVG handles vertical overflow
      // gracefully by fitting the image inside the iRect bounding box.
      var imgEl = section.querySelector('.ne-pb__image');
      var maskImg = section.querySelector('[data-pb-mask-image]');
      if (!imgEl || !maskImg) return;

      function apply() {
        var sRect = section.getBoundingClientRect();
        var iRect = imgEl.getBoundingClientRect();
        if (sRect.width === 0 || sRect.height === 0) return;
        if (iRect.width === 0 || iRect.height === 0) return;
        // maskContentUnits="objectBoundingBox" expects 0-1 fractions
        // (not percentages — those resolve against the SVG viewport
        // which is 0×0 via CSS, breaking the mask).
        var x = ((iRect.left - sRect.left) / sRect.width).toFixed(4);
        var y = ((iRect.top - sRect.top) / sRect.height).toFixed(4);
        var w = (iRect.width / sRect.width).toFixed(4);
        var h = (iRect.height / sRect.height).toFixed(4);
        maskImg.setAttribute('x', x);
        maskImg.setAttribute('y', y);
        maskImg.setAttribute('width', w);
        maskImg.setAttribute('height', h);
      }

      if (imgEl.complete && imgEl.naturalWidth > 0) {
        requestAnimationFrame(apply);
      } else {
        imgEl.addEventListener('load', function () {
          requestAnimationFrame(apply);
        });
      }
      var resizeHandler = function () { apply(); };
      window.addEventListener('resize', resizeHandler, { passive: true });
      section._pbCarveResize = resizeHandler;
    }

    function teardown(section) {
      if (!section) return;
      if (section._pbRaf) {
        try { cancelAnimationFrame(section._pbRaf()); } catch (e) {}
      }
      if (section._pbTimers) {
        section._pbTimers.forEach(function (t) { clearInterval(t); });
        section._pbTimers = null;
      }
      if (section._pbHoldTimer) {
        clearTimeout(section._pbHoldTimer);
        section._pbHoldTimer = null;
      }
      if (section._pbSrHoldTimer) {
        clearTimeout(section._pbSrHoldTimer);
        section._pbSrHoldTimer = null;
      }
      if (section._pbResize) {
        window.removeEventListener('resize', section._pbResize);
        section._pbResize = null;
      }
      if (section._pbResizeObs) {
        try { section._pbResizeObs.disconnect(); } catch (e) {}
        section._pbResizeObs = null;
      }
      if (section._pbDomROTimer) {
        clearTimeout(section._pbDomROTimer);
        section._pbDomROTimer = null;
      }
      if (section._pbDomRO) {
        try { section._pbDomRO.disconnect(); } catch (e) {}
        section._pbDomRO = null;
      }
      if (section._pbCarveResize) {
        window.removeEventListener('resize', section._pbCarveResize);
        section._pbCarveResize = null;
      }
      if (section._pbMql && section._pbMqlHandler) {
        if (section._pbMql.removeEventListener) section._pbMql.removeEventListener('change', section._pbMqlHandler);
        else if (section._pbMql.removeListener) section._pbMql.removeListener(section._pbMqlHandler);
        section._pbMql = null;
        section._pbMqlHandler = null;
      }
      section.dataset.nePbInit = '';
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-ne-pb]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) {
      // Tear down stale instance (selectors might match an old one with
      // the same id pre-reload) and re-init the new section.
      var stale = document.querySelectorAll('[data-ne-pb][data-ne-pb-init="1"]');
      stale.forEach(function (s) { if (!document.contains(s)) teardown(s); });
      initAll(e.target);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var s = e.target.querySelector ? e.target.querySelector('[data-ne-pb]') : null;
      if (s) teardown(s);
    });
    document.addEventListener('shopify:section:select', function (e) {
      // On Customizer reselect, force a re-init to apply setting changes.
      var s = e.target.querySelector ? e.target.querySelector('[data-ne-pb]') : null;
      if (s) { teardown(s); init(s); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  /* Product section JS — gallery + lightbox + variant coordination.
     Bound on every shopify:section:load so customizer DOM swaps don't
     leave stale handlers. Section-scoped via [data-product-section]. */
  (function () {
    function initSection(section) {
      if (!section || section._neProductInitDone) return;
      section._neProductInitDone = true;

      var slides = section.querySelectorAll('[data-media-slide]');
      var thumbs = section.querySelectorAll('[data-thumb-index]');
      var prevBtn = section.querySelector('[data-media-prev]');
      var nextBtn = section.querySelector('[data-media-next]');
      var viewer = section.querySelector('[data-product-media-viewer]');
      var variantsScript = section.querySelector('[data-product-variants]');
      var variants = [];
      try { variants = variantsScript ? JSON.parse(variantsScript.textContent) : []; } catch (e) { variants = []; }
      var current = 0;

      slides.forEach(function (s, i) {
        if (s.classList.contains('ne-product__media-slide--active')) current = i;
      });

      function showSlide(i) {
        if (slides.length === 0) return;
        if (i < 0) i = slides.length - 1;
        if (i >= slides.length) i = 0;
        current = i;
        slides.forEach(function (s, idx) { s.classList.toggle('ne-product__media-slide--active', idx === i); });
        thumbs.forEach(function (t, idx) { t.classList.toggle('ne-product__thumb--active', idx === i); });
        if (thumbs[i]) thumbs[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }

      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { showSlide(i); }); });
      if (prevBtn) prevBtn.addEventListener('click', function () { showSlide(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { showSlide(current + 1); });
      if (viewer) {
        viewer.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft')  { showSlide(current - 1); e.preventDefault(); }
          if (e.key === 'ArrowRight') { showSlide(current + 1); e.preventDefault(); }
        });
      }

      /* Variant coordination — listens to any [data-option-index] input
         change inside this section. Recomputes the matched variant from
         the variants JSON, then updates form id, price, ATC button,
         featured image, URL. */
      function getSelectedOptions() {
        var opts = [];
        var groups = section.querySelectorAll('[data-option-group]');
        groups.forEach(function (group) {
          var radio = group.querySelector('input[type="radio"]:checked');
          var sel = group.querySelector('select');
          if (radio) opts.push(radio.value);
          else if (sel) opts.push(sel.value);
        });
        return opts;
      }

      function updateVariant() {
        var selected = getSelectedOptions();
        if (selected.length === 0) return;
        var match = variants.find(function (v) {
          return v.options.every(function (opt, idx) { return opt === selected[idx]; });
        });
        if (!match) return;

        /* Form hidden input */
        var idInput = section.querySelector('[data-variant-id-input]');
        if (idInput) idInput.value = match.id;

        /* Price */
        var priceCurrent = section.querySelector('[data-product-price-current]');
        var priceCompare = section.querySelector('[data-product-price-compare]');
        var fmt = (window.Shopify && typeof Shopify.formatMoney === 'function')
          ? Shopify.formatMoney
          : function (cents) { return '$' + (cents / 100).toFixed(2); };
        if (priceCurrent) priceCurrent.textContent = fmt(match.price);
        if (priceCompare) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            priceCompare.textContent = fmt(match.compare_at_price);
            priceCompare.hidden = false;
          } else {
            priceCompare.hidden = true;
          }
        }
        var priceWrap = section.querySelector('[data-product-price]');
        if (priceWrap) {
          priceWrap.classList.toggle('ne-product-price--on-sale', !!(match.compare_at_price && match.compare_at_price > match.price));
        }

        /* ATC button */
        var atc = section.querySelector('[data-add-to-cart]');
        if (atc) {
          atc.disabled = !match.available;
          atc.textContent = match.available ? (atc.dataset.addText || 'Add to cart') : (atc.dataset.soldText || 'Sold out');
        }

        /* Low-stock counter — inventory comes from a server-rendered map, NOT
           from the variant JSON (product.variants | json omits inventory_quantity
           + inventory_policy, so match.* would always be undefined → never shown). */
        var stock = section.querySelector('[data-stock-counter]');
        if (stock) {
          var stockThreshold = parseInt(stock.getAttribute('data-stock-threshold'), 10) || 0;
          var stockTmpl = stock.getAttribute('data-stock-template') || '';
          var stockText = stock.querySelector('[data-stock-counter-text]');
          if (!section._neStockMap) {
            var smEl = section.querySelector('[data-stock-map]');
            try { section._neStockMap = smEl ? JSON.parse(smEl.textContent) : {}; }
            catch (e) { section._neStockMap = {}; }
          }
          var sm = section._neStockMap[match.id] || {};
          var stockQty = sm.q;
          var stockTracked = sm.m != null && sm.p !== 'continue';
          if (stockTracked && stockQty > 0 && stockQty <= stockThreshold) {
            if (stockText) stockText.textContent = stockTmpl.replace('[n]', stockQty);
            stock.classList.remove('ne-product-stock--hidden');
          } else {
            stock.classList.add('ne-product-stock--hidden');
          }
        }

        /* Featured image swap */
        if (match.featured_image && match.featured_image.id) {
          slides.forEach(function (s, i) {
            if (parseInt(s.getAttribute('data-media-id'), 10) === match.featured_image.id) showSlide(i);
          });
        }

        /* Selected-value labels */
        var labels = section.querySelectorAll('[data-option-value]');
        labels.forEach(function (label, i) {
          if (selected[i] !== undefined) label.textContent = selected[i];
        });

        /* Swatch / button active states */
        section.querySelectorAll('.ne-product-variants__swatch').forEach(function (s) {
          var inp = s.querySelector('input');
          s.classList.toggle('ne-product-variants__swatch--active', inp && inp.checked);
        });
        section.querySelectorAll('.ne-product-variants__btn').forEach(function (b) {
          var inp = b.querySelector('input');
          b.classList.toggle('ne-product-variants__btn--active', inp && inp.checked);
        });

        /* Pickup availability — refetch for the newly selected variant and
           swap the content node in place. No-op if no pickup block present. */
        var pickup = section.querySelector('[data-pickup-availability]');
        if (pickup) {
          var baseUrl = pickup.getAttribute('data-base-url') || '/';
          var pickupUrl = baseUrl.replace(/\/$/, '') + '/variants/' + match.id + '/?section_id=pickup-availability';
          fetch(pickupUrl, { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.text() : null; })
            .then(function (html) {
              if (!html) return;
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var fresh = doc.querySelector('[data-pickup-content]');
              var current = pickup.querySelector('[data-pickup-content]');
              if (fresh && current) current.replaceWith(fresh);
            })
            .catch(function () { /* leave existing pickup content */ });
        }

        /* URL */
        try {
          var url = new URL(window.location);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url);
        } catch (e) { /* noop */ }
      }

      section.addEventListener('change', function (e) {
        if (e.target.matches('[data-option-index]')) updateVariant();
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-product-section]').forEach(initSection);
    }

    /* Lightbox (per section, body-mounted by browser via showModal()) */
    function bindLightbox(section) {
      var lb = section.querySelector('[data-lightbox]');
      var imagesScript = section.querySelector('[data-lightbox-images]');
      if (!lb || !imagesScript) return;
      if (lb._neBound) return;
      lb._neBound = true;
      var images = [];
      try { images = JSON.parse(imagesScript.textContent); } catch (e) { return; }
      var img = lb.querySelector('[data-lightbox-img]');
      var counter = lb.querySelector('[data-lightbox-counter]');
      var prev = lb.querySelector('[data-lightbox-prev]');
      var next = lb.querySelector('[data-lightbox-next]');
      var thumbs = lb.querySelectorAll('[data-lightbox-thumb]');
      var idx = 0;
      function show(i) {
        idx = (i + images.length) % images.length;
        img.src = images[idx];
        if (counter) counter.textContent = (idx + 1) + ' / ' + images.length;
        thumbs.forEach(function (t, ti) {
          t.classList.toggle('ne-product__lightbox-thumb--active', ti === idx);
        });
        if (thumbs[idx]) thumbs[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
      section.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-lightbox-open]');
        if (!btn) return;
        e.preventDefault();
        show(parseInt(btn.getAttribute('data-lightbox-open'), 10) || 0);
        if (typeof lb.showModal === 'function') lb.showModal();
      });
      var closeBtn = lb.querySelector('[data-lightbox-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { lb.close(); });
      /* Click-anywhere-but-content closes the lightbox. The image, nav
         arrows, close button, and thumbnails are interactive — anything
         else (the dark backdrop area) is treated as a close target. */
      lb.addEventListener('click', function (e) {
        if (e.target.closest('.ne-product__lightbox-img, .ne-product__lightbox-nav, .ne-product__lightbox-close, .ne-product__lightbox-thumb')) return;
        lb.close();
      });
      if (prev) prev.addEventListener('click', function () { show(idx - 1); });
      if (next) next.addEventListener('click', function () { show(idx + 1); });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          show(parseInt(t.getAttribute('data-lightbox-thumb'), 10) || 0);
        });
      });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'Escape')      { lb.close(); }
        if (e.key === 'ArrowLeft')   { show(idx - 1); }
        if (e.key === 'ArrowRight')  { show(idx + 1); }
      });
      /* Touch swipe — horizontal drag beyond threshold paginates (mirrors the
         gallery lightbox). Vertical swipes are ignored so a close/scroll
         gesture still works. The product lightbox previously only paginated
         via the chevron buttons, so touch slide did nothing. */
      var tStartX = 0, tStartY = 0, tActive = false;
      var SWIPE_THRESHOLD = 50;
      lb.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { tActive = false; return; }
        tStartX = e.touches[0].clientX;
        tStartY = e.touches[0].clientY;
        tActive = true;
      }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        if (!tActive) return;
        tActive = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - tStartX;
        var dy = t.clientY - tStartY;
        if (Math.abs(dx) < SWIPE_THRESHOLD || Math.abs(dx) < Math.abs(dy)) return;
        if (dx < 0) show(idx + 1); else show(idx - 1);
      }, { passive: true });
    }
    function bindLightboxAll(scope) {
      (scope || document).querySelectorAll('[data-product-section]').forEach(bindLightbox);
    }

    initAll();
    bindLightboxAll();
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
      bindLightboxAll(e.target);
    });
    document.addEventListener('shopify:block:select', function (e) {
      var sec = e.target.closest('[data-product-section]');
      if (sec) { initAll(sec); bindLightbox(sec); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-search-section]');
    if (!section) return;

    var input = section.querySelector('[data-predictive-input]');
    var resultsWrap = section.querySelector('[data-predictive-results]');
    var content = section.querySelector('[data-predictive-content]');

    /* ─── Predictive search ─────────────────────────────────────── */
    if (input && resultsWrap && content) {
      var debounce;
      var i18n = {
        products: resultsWrap.getAttribute('data-i18n-products') || 'Products',
        articles: resultsWrap.getAttribute('data-i18n-articles') || 'Articles',
        pages: resultsWrap.getAttribute('data-i18n-pages') || 'Pages',
        noSuggestions: resultsWrap.getAttribute('data-i18n-no-suggestions') || 'No suggestions found',
        unavailable: resultsWrap.getAttribute('data-i18n-unavailable') || 'Search unavailable'
      };
      function escapeHtml(s) {
        if (s == null) return '';
        return String(s).replace(/[&<>"']/g, function(c) {
          return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
        });
      }

      function buildSection(label, items, type) {
        if (!items || !items.length) return '';
        var html = '<div class="ne-search__predictive-section">';
        html += '<span class="ne-search__predictive-heading">' + escapeHtml(label) + '</span>';
        items.forEach(function(item) {
          html += '<a class="ne-search__predictive-item" href="' + escapeHtml(item.url) + '">';
          if (type === 'product' && item.image) {
            html += '<img class="ne-search__predictive-img" src="' + escapeHtml(item.image) + '" width="44" height="44" alt="" loading="lazy">';
          }
          html += '<div class="ne-search__predictive-text">';
          html += '<div class="ne-search__predictive-title">' + escapeHtml(item.title) + '</div>';
          if (type === 'product' && item.price) {
            html += '<div class="ne-search__predictive-meta">' + escapeHtml(item.price) + '</div>';
          }
          html += '</div></a>';
        });
        html += '</div>';
        return html;
      }

      input.addEventListener('input', function() {
        clearTimeout(debounce);
        var q = input.value.trim();
        if (q.length < 2) { resultsWrap.hidden = true; return; }

        debounce = setTimeout(function() {
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,article,page&resources[limit]=6')
            .then(function(r) { return r.json(); })
            .then(function(data) {
              var resources = (data && data.resources && data.resources.results) || {};
              var html = '';
              html += buildSection(i18n.products, resources.products, 'product');
              html += buildSection(i18n.articles, resources.articles, 'article');
              html += buildSection(i18n.pages, resources.pages, 'page');
              if (!html) {
                html = '<p class="ne-search__predictive-empty">' + escapeHtml(i18n.noSuggestions) + '</p>';
              }
              content.innerHTML = html;
              resultsWrap.hidden = false;
            })
            .catch(function() {
              content.innerHTML = '<p class="ne-search__predictive-empty">' + escapeHtml(i18n.unavailable) + '</p>';
              resultsWrap.hidden = false;
            });
        }, 250);
      });

      input.addEventListener('focus', function() {
        if (input.value.trim().length >= 2 && content.innerHTML) {
          resultsWrap.hidden = false;
        }
      });

      document.addEventListener('click', function(e) {
        if (!e.target.closest('.ne-search__form-wrap')) resultsWrap.hidden = true;
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') resultsWrap.hidden = true;
      });
    }

    /* ─── Sort: redirect ────────────────────────────────────────── */
    var sortSelect = section.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    /* ─── Filter form ───────────────────────────────────────────── */
    var filterForm = section.querySelector('[data-filter-form]');
    var filterInputs = section.querySelectorAll('[data-filter-input]');
    var debounceTimer;

    function submitFilterForm() {
      if (!filterForm) return;
      var formData = new FormData(filterForm);
      var params = new URLSearchParams();
      for (var pair of formData.entries()) {
        if (pair[1] !== '' && pair[1] !== null && pair[1] !== undefined) {
          params.append(pair[0], pair[1]);
        }
      }
      if (sortSelect && sortSelect.value && !params.has('sort_by')) {
        params.set('sort_by', sortSelect.value);
      }
      // Preserve search query
      var qInput = section.querySelector('input[name="q"]');
      if (qInput && qInput.value && !params.has('q')) {
        params.set('q', qInput.value);
      }
      var qs = params.toString();
      window.location.href = window.location.pathname + (qs ? '?' + qs : '');
    }

    filterInputs.forEach(function(inp) {
      inp.addEventListener('change', function() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(submitFilterForm, 600);
      });
    });

    /* ─── Mobile filter drawer ──────────────────────────────────── */
    var filterToggle = section.querySelector('[data-filter-toggle]');
    var filterSidebar = section.querySelector('[data-filter-sidebar]');
    var filterBackdrop = section.querySelector('[data-filter-backdrop]');
    var filterCloseBtn = section.querySelector('[data-filter-close]');

    function openFilters() {
      if (!filterSidebar) return;
      filterSidebar.setAttribute('data-open', '1');
      if (filterBackdrop) filterBackdrop.setAttribute('data-open', '1');
      if (filterToggle) filterToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeFilters() {
      if (!filterSidebar) return;
      filterSidebar.removeAttribute('data-open');
      if (filterBackdrop) filterBackdrop.removeAttribute('data-open');
      if (filterToggle) filterToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    if (filterToggle) {
      filterToggle.addEventListener('click', function() {
        if (filterSidebar.getAttribute('data-open') === '1') closeFilters(); else openFilters();
      });
    }
    if (filterCloseBtn) filterCloseBtn.addEventListener('click', closeFilters);
    if (filterBackdrop) filterBackdrop.addEventListener('click', closeFilters);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && filterSidebar && filterSidebar.getAttribute('data-open') === '1') closeFilters();
    });

    /* ─── Price range slider ────────────────────────────────────── */
    var priceRanges = section.querySelectorAll('[data-price-range]');
    priceRanges.forEach(function(wrap) {
      var fromSlider = wrap.querySelector('[data-price-thumb="from"]');
      var toSlider = wrap.querySelector('[data-price-thumb="to"]');
      var fromInput = wrap.querySelector('[data-price-input="from"]');
      var toInput = wrap.querySelector('[data-price-input="to"]');
      var fill = wrap.querySelector('[data-price-fill]');
      if (!fromSlider || !toSlider) return;

      var min = parseFloat(wrap.dataset.priceMin) || 0;
      var max = parseFloat(wrap.dataset.priceMax) || 100;

      function updateFill() {
        var fromVal = parseFloat(fromSlider.value);
        var toVal = parseFloat(toSlider.value);
        if (fromVal > toVal) {
          var tmp = fromVal; fromVal = toVal; toVal = tmp;
          fromSlider.value = fromVal; toSlider.value = toVal;
        }
        var pctFrom = ((fromVal - min) / (max - min)) * 100;
        var pctTo = ((toVal - min) / (max - min)) * 100;
        if (fill) {
          fill.style.left = pctFrom + '%';
          fill.style.right = (100 - pctTo) + '%';
        }
      }
      function syncInputs() {
        if (fromInput) fromInput.value = parseFloat(fromSlider.value) === min ? '' : fromSlider.value;
        if (toInput) toInput.value = parseFloat(toSlider.value) === max ? '' : toSlider.value;
      }
      fromSlider.addEventListener('input', function() { updateFill(); syncInputs(); });
      toSlider.addEventListener('input', function() { updateFill(); syncInputs(); });
      fromSlider.addEventListener('change', function() {
        clearTimeout(debounceTimer); debounceTimer = setTimeout(submitFilterForm, 400);
      });
      toSlider.addEventListener('change', function() {
        clearTimeout(debounceTimer); debounceTimer = setTimeout(submitFilterForm, 400);
      });
      updateFill();
    });

    /* ─── Mobile padding override ───────────────────────────────── */
    function applyMobilePadding() {
      var top = section.dataset.mobilePadTop;
      var bot = section.dataset.mobilePadBottom;
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      if (!isMobile || (!top && !bot)) {
        section.style.removeProperty('padding-top');
        section.style.removeProperty('padding-bottom');
        return;
      }
      if (top) section.style.paddingTop = top + 'px';
      if (bot) section.style.paddingBottom = bot + 'px';
    }
    applyMobilePadding();
    window.addEventListener('resize', applyMobilePadding, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlideshows(root) {
      (root || document).querySelectorAll('[data-slideshow]').forEach(function (rotator) {
        if (rotator.__ssInit) return;
        rotator.__ssInit = true;

        var track = rotator.querySelector('[data-ss-track]');
        if (!track) return;

        var slides = Array.prototype.slice.call(track.children);
        if (slides.length === 0) return;

        var dots = rotator.querySelectorAll('[data-ss-dot]');
        var prev = rotator.querySelector('[data-ss-prev]');
        var next = rotator.querySelector('[data-ss-next]');
        var current = 0;
        var timer = null;
        var autoplay = rotator.getAttribute('data-autoplay') === 'true';
        var interval = parseInt(rotator.getAttribute('data-interval') || '6000', 10);

        function setActive(idx) {
          if (idx < 0) idx = 0;
          if (idx >= slides.length) idx = slides.length - 1;
          current = idx;
          dots.forEach(function (d, i) {
            d.classList.toggle('ne-ss__dot--active', i === idx);
            d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
          });
          if (prev) prev.toggleAttribute('disabled', idx === 0);
          if (next) next.toggleAttribute('disabled', idx === slides.length - 1);
        }

        function goTo(idx, smooth) {
          var n = slides.length;
          var nx = ((idx % n) + n) % n;
          var slide = slides[nx];
          if (!slide) return;
          track.scrollTo({
            left: slide.offsetLeft,
            behavior: smooth === false ? 'auto' : 'smooth'
          });
          setActive(nx);
        }

        // IntersectionObserver — track which slide is centered to
        // sync dot state with manual scroll / touch / keyboard.
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.intersectionRatio >= 0.6) {
                var idx = slides.indexOf(entry.target);
                if (idx >= 0) setActive(idx);
              }
            });
          }, { root: track, threshold: [0.6] });
          slides.forEach(function (s) { io.observe(s); });
        }

        function start() {
          if (!autoplay || slides.length < 2) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          stop();
          timer = setInterval(function () {
            var nx = (current + 1) % slides.length;
            goTo(nx);
          }, interval);
        }
        function stop() { if (timer) { clearInterval(timer); timer = null; } }

        if (prev) prev.addEventListener('click', function () { stop(); goTo(current - 1); start(); });
        if (next) next.addEventListener('click', function () { stop(); goTo(current + 1); start(); });
        dots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            stop();
            goTo(parseInt(dot.getAttribute('data-ss-dot'), 10));
            start();
          });
        });

        rotator.addEventListener('mouseenter', stop);
        rotator.addEventListener('mouseleave', start);
        rotator.addEventListener('focusin', stop);
        rotator.addEventListener('focusout', start);
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) stop(); else start();
        });

        setActive(0);
        start();
      });
    }
    document.addEventListener('DOMContentLoaded', function () { initSlideshows(document); });
    document.addEventListener('shopify:section:load', function (e) { initSlideshows(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var t = e.target;
      var rotator = t && t.closest ? t.closest('[data-slideshow]') : null;
      if (rotator) {
        var track = rotator.querySelector('[data-ss-track]');
        if (track) {
          var slides = Array.prototype.slice.call(track.children);
          var found = -1;
          slides.forEach(function (s, i) {
            if (s === t || s.contains(t)) found = i;
          });
          if (found >= 0) {
            track.scrollTo({ left: slides[found].offsetLeft, behavior: 'smooth' });
          }
        }
      }
      initSlideshows((e.target && e.target.parentElement) || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function buildNav(section) {
      // Nav already built? bail.
      if (section.querySelector('.ne-tabs__nav')) return null;

      var inner = section.querySelector('.ne-tabs__inner');
      if (!inner) return null;

      // Find the <template>-marked nav sources from each tab block.
      var templates = Array.prototype.slice.call(
        section.querySelectorAll('template[data-ne-tab-template]')
      );
      if (templates.length === 0) return null;

      // Detect tab style from section class so we can apply inline
      // border-radius — critical.css button-reset has specificity
      // (0,6,1) + !important and beats any descendant rule even with
      // !important. Inline style wins via specificity (1,0,0,0).
      var styleMatch = (section.className.match(/ne-tabs--style-(\w+)/) || []);
      var styleMode = styleMatch[1] || 'underline';
      var radius = '0';
      if (styleMode === 'pill') radius = '999px';
      else if (styleMode === 'button') radius = '8px';

      var nav = document.createElement('div');
      nav.className = 'ne-tabs__nav';
      nav.setAttribute('role', 'tablist');
      nav.setAttribute('aria-label', 'Tabs');

      templates.forEach(function (tpl, i) {
        var tabId = tpl.getAttribute('data-tab-id');
        var title = tpl.getAttribute('data-tab-title') || '';
        var fontVar = tpl.getAttribute('data-tab-font') || '';

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ne-tabs__btn' + (i === 0 ? ' ne-tabs__btn--active' : '');
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        btn.setAttribute('aria-controls', 'ne-tab-panel-' + tabId);
        btn.id = 'ne-tab-btn-' + tabId;
        btn.setAttribute('data-tab-btn', String(i));
        btn.setAttribute('data-tab-target', tabId);
        btn.tabIndex = i === 0 ? 0 : -1;
        if (fontVar) btn.style.fontFamily = fontVar;
        // Inline radius via setProperty 'important' — defeats
        // critical.css button:not(...) reset (Rule 144).
        btn.style.setProperty('border-radius', radius, 'important');
        // a11y fallback when title is empty (icon-only button)
        if (!title) btn.setAttribute('aria-label', 'Tab ' + (i + 1));

        // Clone template content (icon span + optional label span) into button.
        var frag = tpl.content.cloneNode(true);
        btn.appendChild(frag);

        nav.appendChild(btn);
      });

      inner.appendChild(nav);
      return nav;
    }

    function initTabs(root) {
      (root || document).querySelectorAll('[data-tabs-section]').forEach(function (section) {
        if (section.__tabsInit) return;

        buildNav(section);

        var btns = Array.prototype.slice.call(section.querySelectorAll('[data-tab-btn]'));
        var panels = Array.prototype.slice.call(section.querySelectorAll('.ne-tab__panel'));
        if (btns.length === 0 || panels.length === 0) return;

        section.__tabsInit = true;

        // id → panel map (DOM order may differ from nav order due to
        // CSS flex-order; matching by id keeps button↔panel correct).
        var byId = {};
        panels.forEach(function (p) { byId[p.getAttribute('data-tab-id')] = p; });

        function activate(idx) {
          btns.forEach(function (b, i) {
            var on = i === idx;
            b.classList.toggle('ne-tabs__btn--active', on);
            b.setAttribute('aria-selected', on ? 'true' : 'false');
            b.setAttribute('tabindex', on ? '0' : '-1');
            var target = byId[b.getAttribute('data-tab-target')];
            if (target) target.hidden = !on;
          });
        }

        btns.forEach(function (btn, i) {
          btn.addEventListener('click', function () { activate(i); });
          btn.addEventListener('keydown', function (e) {
            var n = btns.length;
            if (e.key === 'ArrowRight') {
              e.preventDefault();
              var nx = (i + 1) % n;
              btns[nx].focus();
              activate(nx);
            } else if (e.key === 'ArrowLeft') {
              e.preventDefault();
              var pv = (i - 1 + n) % n;
              btns[pv].focus();
              activate(pv);
            } else if (e.key === 'Home') {
              e.preventDefault();
              btns[0].focus();
              activate(0);
            } else if (e.key === 'End') {
              e.preventDefault();
              btns[n - 1].focus();
              activate(n - 1);
            }
          });
        });

        activate(0);
      });
    }

    document.addEventListener('DOMContentLoaded', function () { initTabs(document); });
    document.addEventListener('shopify:section:load', function (e) { initTabs(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var t = e.target;
      var section = t && t.closest ? t.closest('[data-tabs-section]') : null;
      if (!section) return;
      // If this is the first time after a customizer block-add, init.
      initTabs(section.parentElement || document);
      var panel = t.classList && t.classList.contains('ne-tab__panel') ? t : (t.querySelector ? t.querySelector('.ne-tab__panel') : null);
      if (!panel) return;
      var tabId = panel.getAttribute('data-tab-id');
      var btns = section.querySelectorAll('[data-tab-btn]');
      btns.forEach(function (b) {
        if (b.getAttribute('data-tab-target') === tabId) b.click();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
